import { useRef, forwardRef, useState, useEffect, lazy, Suspense } from "react";
import * as Llamadas from "./Llamadas";
import * as Utils from "./Utils";
import DatePicker from "react-datepicker";
import { addDays, set, subDays } from "date-fns";
import { Liferay } from "../common/services/liferay/liferay";
import Fuse from "fuse.js";
import { format } from 'date-fns';
import { es } from 'date-fns/locale';


const Spinner = lazy(() => import("./Spinner"));
const MensajeVacio = lazy(() => import("./MensajeVacio"));
function Buscador(props) {
  const [locale, setLocale] = useState(null);

  useEffect(() => {
    const lang = Liferay.ThemeDisplay.getBCP47LanguageId();
    const loadLocale = async () => {
      const locales = {
        "es-ES": () => import("date-fns/locale/es"),
        "en-US": () => import("date-fns/locale/en-US"),
        "ca-ES": () => import("date-fns/locale/ca"),
        "eu-ES": () => import("date-fns/locale/eu"),
        "gl-ES": () => import("date-fns/locale/gl"),
        "de-DE": () => import("date-fns/locale/de"),
        "fr-FR": () => import("date-fns/locale/fr"),
        "it-IT": () => import("date-fns/locale/it"),
        "pt-PT": () => import("date-fns/locale/pt"),
      };
      if (locales[lang]) {
        const mod = await locales[lang]();
        setLocale(mod.default);
      }
    };
    loadLocale();
  }, []);

  const trad = props.traducciones;

  const configuraciones = props.configuraciones;
  //const [distance, setDistance] = useState('')
  //const [duration, setDuration] = useState('')

  /*
  const origenRef = useRef();
  const destinoRef = useRef();
  const origenRefCambiado = useRef();
  const destinoRefCambiado = useRef();
  */

  //Refs de calendarios para onclick
  const CalendarioIdaRef = useRef(null);
  const CalendarioVueltaRef = useRef(null);

  // Inputs de datepickers
  const InputPersonalizado = forwardRef(
    ({ value, onClick, className }, ref) => (
      <div
        style={{
          cursor: "pointer",
          paddingTop: "20px",
          padding: "20px 16px 8px",
          fontSize: "1rem",
          lineHeight: "1.5556rem",
        }}
        ref={ref}
        onClick={() => {
          if (CalendarioIdaRef.current) {
            CalendarioIdaRef.current.toggleCalendar();
          }
          if (CalendarioVueltaRef.current) {
            CalendarioVueltaRef.current.setOpen(false);
          }
          ocultarDesplegablesHoras();
        }}
        className={className}
        role="button"
        aria-label="Calendario ida"
        tabIndex="0"
      >
        <label
          style={{ paddingInline: "0px", whiteSpace: "nowrap" }}
          className={
            "input-container-label " + (fechaIda ? "label-traslt" : "")
          }
        >
          {getTextoLabelIda()}
        </label>
        <p
          className="input-p-text"
          style={
            value
              ? {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "0.899rem",
              }
              : {
                color: "grey",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "0.899rem",
              }
          }
          title={!value && Llamadas.traducir(trad?.placeholderida_i18n)}
        >
          {value ? value : Llamadas.traducir(trad?.placeholderida_i18n)}
        </p>
      </div>
    )
  );

  const InputPersonalizadoVuelta = forwardRef(
    ({ value, onClick, className }, ref) => (
      <div
        style={{
          cursor: "pointer",
          paddingTop: "20px",
          padding: "20px 16px 8px",
          fontSize: "1rem",
          lineHeight: "1.5556rem",
        }}
        ref={ref}
        onClick={() => {
          if (CalendarioVueltaRef.current) {
            CalendarioVueltaRef.current.toggleCalendar();
          }
          if (CalendarioIdaRef.current) {
            CalendarioIdaRef.current.setOpen(false);
          }
          ocultarDesplegablesHoras();
        }}
        className={className}
        role="button"
        aria-label="Calendario ida"
        tabIndex="0"
      >
        <label
          style={
            fechaVuelta
              ? { paddingInline: "0px", whiteSpace: "nowrap" }
              : { paddingInline: "0px" }
          }
          className={
            "input-container-label " + (fechaVuelta ? "label-traslt" : "")
          }
        >
          {getTextoLabelVuelta()}
        </label>
        <p
          className="input-p-text"
          style={
            value
              ? {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "0.899rem",
              }
              : {
                color: "grey",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "0.899rem",
              }
          }
        >
          {value ? value : Llamadas.traducir(trad?.bodyopcional_i18n)}
        </p>
        <button
          style={fechaVuelta ? {} : { display: "none" }}
          type="button"
          class="react-datepicker__closedate"
          aria-label="borrar fecha"
          title="Borrar fecha"
          onClick={() => {
            setFechaVuelta(undefined);
            setocultarHorasTrasOKVuelta(true);
            setdiaSeleccionadoVuelta(undefined);
            sethoraSeleccionadaVuelta(undefined);
            setMinutoSeleccionadoVuelta(undefined);
          }
          }
        >
          <img
            src="/o/spain-transfers-theme/assets/sm/icons/general/close-circle.svg"
            alt="Icono borrar fecha"
            class="icoClosedate"
          />
        </button>
      </div>
    )
  );

  const [listaDinamicaOrigen, setListOrigen] = useState(
    props.listaAeropuertosAPI
  );
  const [listaAeropuertos, setListAeropuertos] = useState(
    props.listaAeropuertosAPI
  );
  const [listaDinamicaDestinos, setListDestino] = useState(
    props.listaAeropuertosAPI
  );
  const [listaLocalizaciones, setListLocalizaciones] = useState(
    []
  );
  //let [listaDinamicaCopia, setListCopia] = useState([]);

  //Para destinos primero
  //let [listaAreas, setListAreas] = useState(props.localizacionesAreasJuntas.areas);
  //let [listaLocalizaciones, setListLocalizaciones] = useState(props.localizacionesAreasJuntas.localizaciones);
  //let [listaAreasConjunta, setListAreasConjunta] = useState([]);
  //let [listaAeropuertosDestino, setListAeropuertoDestino] = useState([]);
  //let [listaAeropuertosDestinoCopia, setListAeropuertoDestinoCopia] = useState(listaAeropuertosDestino);

  const [destinosDesactivado, setDestinosDesactivado] = useState(true);
  const [origenDesactivado, setOrigenDesactivado] = useState(false);
  const [fechasDesactivado, setFechasDesactivado] = useState(true);
  const [fechasVueltaDesactivado, setFechasVueltaDesactivado] = useState(true);
  const [pasajerosDesactivado, setPasajerosDesactivado] = useState(true);
  const [enviarDesactivado, setEnviarDesactivado] = useState(true);
  const [cambiarDesactivado, setCambiarDesactivado] = useState(true);
  //const [destinosAeropuertoDesactivado, setDestinosAeropuertoDesactivado] = useState(true);
  const [ocultarListaDestino, setOcultarListaDestino] = useState(true);
  const [ocultarListaOrigen, setOcultarListaOrigen] = useState(true);

  const [origen, setOrigen] = useState();
  const [dest, setDest] = useState();
  const [origenAeropuerto, setOrigenAeropuerto] = useState(true);

  const [fechaIda, setFechaIda] = useState();
  const [fechaVuelta, setFechaVuelta] = useState();
  const [fechasValidas, setFechasValidas] = useState([
    {
      start: new Date(new Date().getTime() + (configuraciones.buscadorPlazoMinimoHora * 60 * 60 * 1000) + (configuraciones.buscadorPlazoMinimoMinutos * 60 * 1000)),
      end: new Date(new Date().getFullYear(), 11, 31),
    },
  ]);
  const [fechasValidasVuelta, setFechasValidasVuelta] = useState([]);
  const [fechasValidasFiltradas, setfechasValidasFiltradas] = useState(true);
  const [horaMin, setHoraMin] = useState(new Date());
  const [horaMax, setHoraMax] = useState(Utils.ajustarHora(new Date(), 23, 59));
  const [ocultarHoras, setocultarHoras] = useState(true);
  const [ocultarMinutos, setocultarMinutos] = useState(true);
  const [ocultarHorasTrasOK, setocultarHorasTrasOK] = useState(true);
  const [hechoDeshabilitado, setHechoDeshabilitado] = useState(true);
  const [ocultarHorasVuelta, setocultarHorasVuelta] = useState(true);
  const ulRef = useRef(null);
  const [ocultarMinutosVuelta, setocultarMinutosVuelta] = useState(true);
  const [ocultarHorasTrasOKVuelta, setocultarHorasTrasOKVuelta] =
    useState(true);
  const [hechoDeshabilitadoVuelta, setHechoDeshabilitadoVuelta] =
    useState(true);
  const [horaMinVuelta, setHoraMinVuelta] = useState(
    Utils.ajustarHora(new Date(), 23, 59)
  );
  const [horaMaxVuelta, setHoraMaxVuelta] = useState(
    Utils.ajustarHora(new Date(), 23, 59)
  );
  const [listaMinutosValidos, setlistaMinutosValidos] = useState([
    0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55,
  ]);
  const [diaSeleccionado, setdiaSeleccionado] = useState();
  const [horaSeleccionada, sethoraSeleccionada] = useState();
  const [minutoSeleccionado, setMinutoSeleccionado] = useState();
  const [listaMinutosValidosVuelta, setlistaMinutosValidosVuelta] = useState([
    0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55,
  ]);
  const [diaSeleccionadoVuelta, setdiaSeleccionadoVuelta] = useState();
  const [horaSeleccionadaVuelta, sethoraSeleccionadaVuelta] = useState();
  const [minutoSeleccionadoVuelta, setMinutoSeleccionadoVuelta] = useState();
  const [tarifasValidas, setListaTarifasValidas] = useState([]);
  const [fechasExcluidas, setFechasExcluidas] = useState([]);

  const [pasajeros, setPasajeros] = useState({
    adultos: 1,
    ninos: 0,
    bebes: 0,
  });
  const [maxPasajeros, setMaxPasajeros] = useState(1);
  const [minPasajeros, setMinPasajeros] = useState(1);

  const [searchTermDestino, setSearchTermDestino] = useState({
    texto: "",
    actualizar: true,
  });
  const [searchTermOrigen, setSearchTermOrigen] = useState({
    texto: "",
    actualizar: true,
  });

  const [variables, setVariables] = useState(props.variables);
  const [variablesCargar, setVariablesCargar] = useState(
    props.variables != undefined
  );

  const [pasajeroCerrado, setPasajeroCerrado] = useState(true);
  const [textoPasajeros, setTextoPasajeros] = useState(
    "1 " + Llamadas.traducir(trad.adulto_i18n)?.toLocaleLowerCase()
  );
  const [spinnerDestinoActivado, setSpinnerDestinoActivado] = useState(false);
  const [spinnerOrigenActivado, setSpinnerOrigenActivado] = useState(false);

  const [mensajeVacioOrigenActivado, setMensajeVacioOrigenActivado] = useState(false);
  const [mensajeVacioDestinoActivado, setMensajeVacioDestinoActivado] = useState(false);

  const [primeroSeleccionado, setPrimeroSeleccionado] = useState();

  const botonRef = useRef(null);

  //const [textoDestino, setTextoDestino] = useState("");
  //const [textoOrigen, setTextoOrigen] = useState("");

  //retrasar busqueda hasta que pare de escribir en destino
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTermDestino.actualizar) {
        if (
          !primeroSeleccionado ||
          (primeroSeleccionado &&
            primeroSeleccionado?.posicionOrigen == false &&
            !(origen && dest))
        ) {
          filtrarAmbos(searchTermDestino.texto, false);
        } else {
          if (dest?.posicionOrigen == false || origen?.posicionOrigen == true) {
            filtrarResultados(
              searchTermDestino.texto,
              origen,
              listaLocalizaciones,
              false
            );
          } else {
            filtrarAeropuertos(searchTermDestino.texto, false);
          }
        }
        if (searchTermDestino.texto == "") {
          (false);
        }
      }
      //setTextoDestino(searchTerm.texto);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTermDestino]);

  //retrasar busqueda hasta que pare de escribir en origen
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTermOrigen.actualizar) {
        if (
          !primeroSeleccionado ||
          (primeroSeleccionado &&
            primeroSeleccionado?.posicionOrigen == true &&
            !(origen && dest))
        ) {
          filtrarAmbos(searchTermOrigen.texto, true);
        } else {
          if (dest?.posicionOrigen == false || origen?.posicionOrigen == true) {
            filtrarAeropuertos(searchTermOrigen.texto, true);
          } else {
            filtrarResultados(
              searchTermOrigen.texto,
              origen,
              listaLocalizaciones,
              true
            );
          }
        }
        if (searchTermOrigen.texto == "") {
          limpiarCampo(true);
        }
      }
      //setTextoOrigen(searchTermOrigen.texto);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTermOrigen]);
  //Buscador horas y minutos
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!ulRef.current) return;

      const key = event.key;
      if (!/^\d$/.test(key)) return; // Solo dígitos 0-9

      const items = ulRef.current.querySelectorAll('li');
      const index = Array.from(items).findIndex(li => li.textContent.trim() === key);
      if (index >= 0) {
        items[index].scrollIntoView({ behavior: "smooth", block: "center" });
        items[index].focus?.();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //habilitar o deshabilitar el boton de las horas
  useEffect(() => {
    if (horaSeleccionada != undefined && minutoSeleccionado != undefined && diaSeleccionado != undefined) {
      setHechoDeshabilitado(false);
    } else {
      setHechoDeshabilitado(true);
    }
  }, [horaSeleccionada, fechaIda, minutoSeleccionado]);

  const hhmmRef = useRef(null);

  // Ocultar cuando se hace clic fuera
useEffect(() => {
  const handleClickOutside = (event) => {


     const target = event.target;




    if (hhmmRefVuelta.current && !hhmmRefVuelta.current.contains(event.target)) {
      setocultarHorasTrasOKVuelta(true);
      actualizarFechas();
    }
     if (
                 botonRef.current &&
                 botonRef.current.className === target.className
               ) {
               actualizarFechaVueltaConHoras(diaSeleccionadoVuelta, horaSeleccionadaVuelta, minutoSeleccionadoVuelta);


                 enviarDatos();

               }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };

}, [fechaIda, horaSeleccionadaVuelta, fechaVuelta, minutoSeleccionadoVuelta]);



  const hhmmRefVuelta = useRef(null);

  // Ocultar cuando se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        hhmmRefVuelta.current &&
        !hhmmRefVuelta.current.contains(event.target)
      ) {
        setocultarHorasTrasOKVuelta(true); // Oculta el div
        actualizarFechas();
      } if (hhmmRefVuelta?.current?.contains(event.target) && event?.target?.className != "li-boxhm li-h") {
        setocultarHorasVuelta(true);
      } if (hhmmRefVuelta?.current?.contains(event.target) && event?.target?.className != "li-boxhm li-m") {
        setocultarMinutosVuelta(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [actualizarFechas]);


  useEffect(() => {
    if (horaSeleccionadaVuelta != undefined && minutoSeleccionadoVuelta != undefined && diaSeleccionadoVuelta != undefined) {
      setHechoDeshabilitadoVuelta(false);
    } else {
      setHechoDeshabilitadoVuelta(true);
    }
  }, [horaSeleccionadaVuelta, fechaVuelta, minutoSeleccionadoVuelta]);

  //inicializar fecha ida
  useEffect(() => {
    const fechaSelecccionadaDefecto = async () => {
      //48 horas por defecto
      var fechaAplazada = new Date(new Date().getTime() + (configuraciones.buscadorPlazoDefectoHora * 60 * 60 * 1000) + (configuraciones.buscadorPlazoDefectoMinutos * 60 * 1000));
      let fechaRedondeada = Utils.redondearFecha(fechaAplazada);
      let activarPasajeros = false;
      seleccionarFechaIda(fechaRedondeada, activarPasajeros);
      setocultarHorasTrasOK(true);
      actualizarFechaIdaConHoras(fechaRedondeada, fechaRedondeada.getHours(), fechaRedondeada.getMinutes());
    }
    fechaSelecccionadaDefecto();

  }, []);

  //cargar variables solo al inicializar
  useEffect(async () => {
    let ignore = false;

    if (!ignore) {
      let res = await cargarVariables(props.listaAeropuertosAPI);

    }
    return () => {
      ignore = true;
    };
  }, []);

  //Deshabilitar campo pasajeros cuando destino es vacío
  useEffect(() => {
    const cambiarPasajerosDesactivado = async () => {
      if (origen?.posicionOrigen == false || dest?.posicionOrigen == false) {
        setPasajerosDesactivado(false);
        if (fechaIda) {
          let result = validarFechaIda(fechaIda);
          let { fecha, nueva, horaMaxima, horaMinima, listaTemp } = result;
          let { minPersonas, maxPersonas } = Utils.getMaxMinPasajeros(
            tarifasValidas,
            fecha
          );
          if (minPersonas > 1 && minPersonas != Infinity) {
            setPasajeros({
              adultos: minPersonas,
              ninos: 0,
              bebes: 0,
            });
            getTextoPasajeros({
              adultos: minPersonas,
              ninos: 0,
              bebes: 0,
            });
          }
          setMaxPasajeros(maxPersonas);
          setMinPasajeros(minPersonas);
        }
      } else {
        setPasajerosDesactivado(true);
      }
    }
    cambiarPasajerosDesactivado();
  }, [origen, dest, tarifasValidas]);

  //Función usada para filtrar los origenes disponibles según texto
  function getTextoLabelIda() {
    let texto = "";
    if (origen?.tipoEstacion?.key == "aeropuerto") {
      if (isAeropuertoPrimero()) {
        texto = Llamadas.traducir(trad.literalidaaeropuerto_i18n);
      } else {
        texto = Llamadas.traducir(trad.literalvueltaaeropuerto_i18n);
      }
    } else {
      texto = Llamadas.traducir(trad.fechaIda_i18n);
    }
    if (!origen) {

      texto = Llamadas.traducir(trad.fechaIda_i18n);

    }

    return texto;
  }


  function getTextoLabelVuelta() {
    let texto = "";
    if (origen?.tipoEstacion?.key == "aeropuerto") {
      if (isAeropuertoPrimero()) {
        texto = Llamadas.traducir(trad.literalvueltaaeropuerto_i18n);
      } else {
        texto = Llamadas.traducir(trad.literalidaaeropuerto_i18n);
      }
    } else {
      texto = Llamadas.traducir(trad.fechavuelta_i18n);
    }

    if (!origen) {
      texto = Llamadas.traducir(trad.fechavuelta_i18n);
    }

    return texto;
  }

 
  /**function getTextoLabelHora() {
    let texto = "";
    if (origen?.tipoEstacion?.key == "aeropuerto") {
      if (isAeropuertoPrimero()) {
        texto = Llamadas.traducir(trad.horaidaaeropuerto_i18n);
      } else {
        texto = Llamadas.traducir(trad.horavueltaaeropuerto_i18n);
      }
    } else {
      if (isAeropuertoPrimero()) {
        texto = Llamadas.traducir(trad.horaida_i18n);
      } else {
        texto = Llamadas.traducir(trad.horavuelta_i18n);
      }
    }

    return texto;
  }*/

  function getListaHoras() {
    let horaMinInt = horaMin.getHours();
    let horaMaxInt = horaMax.getHours();

    let listaHoras = [];

    for (let i = horaMinInt; i <= horaMaxInt; i++) listaHoras.push(i);

    return listaHoras;
  }

  function getListaHorasVuelta() {
    let horaMinInt = horaMinVuelta.getHours();
    let horaMaxInt = horaMaxVuelta.getHours();

    let listaHoras = [];

    for (let i = horaMinInt; i <= horaMaxInt; i++) listaHoras.push(i);

    return listaHoras;
  }

  function actualizarFechaIdaConHoras(fecha, hora, minuto) {
    if (fecha != undefined && hora != undefined && minuto != undefined) {
      let fechaCombinada = Utils.ajustarHora(
        fecha,
        hora,
        minuto
      );
      let resultado = validarFechaIda(fechaCombinada);
      if (resultado?.fecha) {
        let fechaRedondeada = Utils.redondearFecha(resultado?.fecha);
        setFechaIda(fechaRedondeada);
        setdiaSeleccionado(fechaRedondeada);
        sethoraSeleccionada(fechaRedondeada.getHours());
        setMinutoSeleccionado(fechaRedondeada.getMinutes());
      } else {
        //alerterrorvalidacionfechaida
        //window.alert("ERROR VALIDACION FECHA IDA");
        window.alert(Llamadas.traducir(trad.alerterrorvalidacionfechaida_i18n));
      }
    }
  }

  function actualizarFechaVueltaConHoras(fecha, hora, minuto) {
    if (fecha != undefined && hora != undefined && minuto != undefined) {
      let fechaCombinada = Utils.ajustarHora(
        fecha,
        hora,
        minuto
      );
      let resultado = validarFechaVuelta(fechaCombinada);
      if (resultado?.fecha) {
        let fechaRedondeada = Utils.redondearFecha(resultado?.fecha);
        setFechaVuelta(fechaRedondeada);
        setdiaSeleccionadoVuelta(fechaRedondeada);
        sethoraSeleccionadaVuelta(fechaRedondeada.getHours());
        setMinutoSeleccionadoVuelta(fechaRedondeada.getMinutes());
      } else {
        //alerterrorvalidacionfechavuelta
        //window.alert("ERROR VALIDACION FECHA VUELTA");
        window.alert(Llamadas.traducir(trad.alerterrorvalidacionfechavuelta_i18n));
      }
    }
  }

  function actualizarListaMinutos(min, max, hora, ida) {
    let minutoMinimo = 0;
    let minutoMaximo = 60;
    let listaMinutos = [];
    if (min && hora == min.getHours()) minutoMinimo = min.getMinutes();

    if (max && hora == max.getHours()) minutoMaximo = max.getMinutes();

    for (let i = minutoMinimo; i < minutoMaximo; i = i + 5) {
      listaMinutos.push(i);
    }
    ida ?
      setlistaMinutosValidos(listaMinutos) :
      setlistaMinutosValidosVuelta(listaMinutos);
  }


  function seleccionarHora(horaParam) {
    let hora = horaParam;
    setocultarHoras(true);
    actualizarListaMinutos(horaMin, horaMax, hora, true);
    if (minutoSeleccionado != undefined) {
      actualizarFechaIdaConHoras(diaSeleccionado, hora, minutoSeleccionado);
    }
    sethoraSeleccionada(hora);

  }

  function seleccionarHoraVuelta(horaParam) {
    let hora = horaParam;
    setocultarHorasVuelta(true);
    actualizarListaMinutos(horaMinVuelta, horaMaxVuelta, hora, false);
    if (minutoSeleccionadoVuelta != undefined) {
      actualizarFechaVueltaConHoras(diaSeleccionadoVuelta, hora, minutoSeleccionadoVuelta);
    }
    sethoraSeleccionadaVuelta(hora);
  }

  function seleccionarMinuto(minutoParam) {
    let minuto = minutoParam;
    setocultarMinutos(true);
    if (horaSeleccionada != undefined) {
      actualizarFechaIdaConHoras(diaSeleccionado, horaSeleccionada, minuto);
    }
    setMinutoSeleccionado(minuto);

  }

  function seleccionarMinutoVuelta(minutoParam) {
    let minuto = minutoParam;
    setocultarMinutosVuelta(true);
    if (horaSeleccionadaVuelta != undefined) {
      actualizarFechaVueltaConHoras(diaSeleccionadoVuelta, horaSeleccionadaVuelta, minuto);

    }
    setMinutoSeleccionadoVuelta(minuto);
  }
  //Función usada para filtrar los origenes disponibles según texto
  async function filtrarAmbos(texto, posicionOrigen = true) {
    let combo = props.listaAeropuertosAPI;
    let listaTemp = [];
    if (texto != "") {
      posicionOrigen
        ? setOcultarListaOrigen(false)
        : setOcultarListaDestino(false);

      /*
      listaTemp = props.listaAeropuertosAPI.filter((elem) =>
        Utils.eliminarAcentos(elem.nombre.toUpperCase()).includes(
          Utils.eliminarAcentos(texto.toUpperCase())
        )
      );*/
      listaTemp = busquedaFuzzy(props.listaAeropuertosAPI, texto, ["nombre"]);
      let resultados = await filtrarResultadosNuevo(texto);
      /*let listaTempSort=listaTemp?.sort((a, b) =>
        a?.nombre.localeCompare(b?.nombre));*/
      let listaResultadosSort = resultados?.sort((a, b) =>
        a.nombre.localeCompare(b.nombre));
      combo = [...listaTemp, ...listaResultadosSort];
    } else {
      //limpiarCampo(posicionOrigen);
    }
    posicionOrigen ? setListOrigen(combo) : setListDestino(combo);
    if(combo?.length == 0) {
      posicionOrigen ? setMensajeVacioOrigenActivado(true) : setMensajeVacioDestinoActivado(true);
    } else{
      posicionOrigen ? setMensajeVacioOrigenActivado(false) : setMensajeVacioDestinoActivado(false);
    }
    return combo;
  }

  function busquedaFuzzy(lista, texto, claves) {
    if (texto == "") {
      return lista;
    }
    let fixedStr = configuraciones.configuracionBusqueda
      .replace(/(\w+)\s*:/g, '"$1":') // agrega comillas a las claves
      .replace(/\\"/g, '"'); // reemplaza \" por "
    const options = JSON.parse(fixedStr);
    const fuse = new Fuse(lista, options);
    const result = fuse.search(texto);
    return result.map(resultado => resultado.item);
  }

  async function filtrarAeropuertos(texto, posicionOrigen = true) {
    let combo = [];
    let listaTemp = props.listaAeropuertosAPI;
    if (texto != "") {
      posicionOrigen
        ? setOcultarListaOrigen(false)
        : setOcultarListaDestino(false);
    } else {
      //limpiarCampo(posicionOrigen);
    }

    if (dest) {
      /*
      listaTemp = listaAeropuertos.filter((elem) =>
        Utils.eliminarAcentos(elem.nombre.toUpperCase()).includes(
          Utils.eliminarAcentos(texto.toUpperCase())
        )
      );
      */
      listaTemp = busquedaFuzzy(listaAeropuertos, texto, ["nombre"]);

    } else {
      /*
      listaTemp = props.listaAeropuertosAPI.filter((elem) =>
        Utils.eliminarAcentos(elem.nombre.toUpperCase()).includes(
          Utils.eliminarAcentos(texto.toUpperCase())
        )
      );
      */
      listaTemp = busquedaFuzzy(props.listaAeropuertosAPI, texto, ["nombre"]);
    }
    //combo = listaTemp.sort((a, b) => a.nombre.localeCompare(b.nombre));
    combo = listaTemp;
    posicionOrigen ? setListOrigen(combo) : setListDestino(combo);
    if(combo?.length == 0) {
      posicionOrigen ? setMensajeVacioOrigenActivado(true) : setMensajeVacioDestinoActivado(true);
    } else{
      posicionOrigen ? setMensajeVacioOrigenActivado(false) : setMensajeVacioDestinoActivado(false);
    }
    return combo;
  }

  function seleccionarElemento(elem, posicionOrigen) {
    if (elem.tipoDestino == "estacion") {
      if (!origen && !dest) {
        seleccionarAeropuerto(elem, posicionOrigen);
      } else if (origen) {
        if (
          primeroSeleccionado?.tipoDestino == "estacion" &&
          primeroSeleccionado?.posicionOrigen == posicionOrigen
        ) {
          seleccionarAeropuerto(elem, posicionOrigen);
        } else {
          seleccionarAeropuertoSinOrigen(elem, posicionOrigen);
        }
      } else if (dest) {
        if (
          primeroSeleccionado?.tipoDestino != "estacion" &&
          primeroSeleccionado?.posicionOrigen == posicionOrigen
        ) {
          seleccionarAeropuerto(elem, posicionOrigen);
        } else {
          seleccionarAeropuertoSinOrigen(elem, posicionOrigen);
        }
      }
      /*
      if((!origen && !dest) || (origen.posicionOrigen==posicionOrigen && !dest) || (dest && dest.posicionOrigen!=posicionOrigen)) {
        seleccionarAeropuertoSinOrigen(elem, posicionOrigen);
      } else {
        seleccionarAeropuerto(elem, posicionOrigen);
      }
      */
    } else {
      /*
      if((!origen && !dest) || (dest?.posicionOrigen==posicionOrigen && !origen)) {
        seleccionarDestinoSinOrigen(elem, posicionOrigen);
      } else {
        seleccionarDestino(elem, origen, posicionOrigen);
      }
      */
      if (!origen && !dest) {
        seleccionarDestinoSinOrigen(elem, posicionOrigen);
      } else if (origen) {
        if (
          primeroSeleccionado?.tipoDestino == "estacion" &&
          primeroSeleccionado?.posicionOrigen == posicionOrigen
        ) {
          seleccionarDestinoSinOrigen(elem, posicionOrigen);
        } else {
          seleccionarDestino(elem, origen, posicionOrigen);
        }
      } else if (dest) {
        seleccionarDestinoSinOrigen(elem, posicionOrigen);
      }
    }
  }

  async function seleccionarDestinoSinOrigen(elem, posicionOrigen) {
    var datos = await Llamadas.getDatosDestinoNested(
      elem,
      props.areasOriginales
    );
    posicionOrigen ? setListDestino(datos) : setListOrigen(datos);

    let origenParam = origen;

    setListAeropuertos(datos);
    setDest({
      ...elem,
      posicionOrigen: posicionOrigen,
    });

    if (
      !primeroSeleccionado ||
      (primeroSeleccionado?.posicionOrigen == posicionOrigen &&
        !(origenParam && elem)) ||
      origenParam.posicionOrigen == posicionOrigen
    ) {
      setPrimeroSeleccionado({ ...elem, posicionOrigen: posicionOrigen });
      setDestinosDesactivado(false);
      setFechasDesactivado(false);
      setFechasVueltaDesactivado(false);
      setCambiarDesactivado(false);
      if (origenParam) {
        origenParam = undefined;
        setOrigen(origenParam);
      }
    }

    setOcultarListaDestino(true);
    setOcultarListaOrigen(true);

    posicionOrigen ? setListOrigen([]) : setListDestino([]);

    posicionOrigen
      ? setSearchTermOrigen({ texto: elem.nombre, actualizar: false })
      : setSearchTermDestino({ texto: elem.nombre, actualizar: false });

    if (origenParam) {
      return filtrarFechasTarifa(elem, origenParam);
    }
  }

  //Función usada para seleccionar un origen
  async function seleccionarAeropuerto(elem, posicionOrigen) {
    posicionOrigen
      ? setSpinnerOrigenActivado(true)
      : setSpinnerDestinoActivado(true);

    let origenNuevo = await Llamadas.getTodoAeropuertoNested(elem.id);
    Utils.logger("Origen nuevo");
    Utils.logger(origenNuevo);

    let destinoParam = dest;

    let destinos = [];
    origenNuevo.tarifas.forEach((tarifa) => {
      tarifa.localizacionesConPrecios.forEach((localizacion) => {
        destinos.push({
          id: localizacion.id,
          precio: localizacion.precio,
          place_id: "",
          nombre: localizacion.nombre,
          location: "",
          key: localizacion.key,
          type: "location",
          tipoDestino: "tomtom",
          textoBusqueda: localizacion.textoBusqueda

        });
      });
    });

    //Stop sales
    if (elem.stopSales) {
      setFechasExcluidas([
        {
          start: Utils.convertUTCToLocalTime(elem.fechaInicioStopSales),
          end: Utils.convertUTCToLocalTime(elem.fechaFinStopSales),
        },
      ]);
    }

    setOrigen({
      ...origenNuevo,
      posicionOrigen: posicionOrigen,
    });

    if (
      !primeroSeleccionado ||
      (primeroSeleccionado?.posicionOrigen == posicionOrigen &&
        !(origenNuevo && destinoParam)) ||
      origenNuevo.posicionOrigen == destinoParam.posicionOrigen
    ) {
      setPrimeroSeleccionado({
        ...origenNuevo,
        posicionOrigen: posicionOrigen,
      });
      setDestinosDesactivado(false);
      setFechasDesactivado(false);
      setFechasVueltaDesactivado(false);
      setCambiarDesactivado(false);
      if (destinoParam) {
        destinoParam = undefined;
        setDest(destinoParam);
      }
    }
    //setListCopia(destinos);
    posicionOrigen ? setListDestino(destinos) : setListOrigen(destinos);
    setListLocalizaciones(destinos);

    posicionOrigen
      ? setSearchTermOrigen({ texto: origenNuevo.nombre, actualizar: false })
      : setSearchTermDestino({ texto: origenNuevo.nombre, actualizar: false });

    //limpiar datos
    setDestinosDesactivado(false);
    setFechasDesactivado(true);
    setFechasVueltaDesactivado(true);
    if (destinoParam) {
      let valido = await Llamadas.validarOrigenDestino(
        origenNuevo,
        destinoParam
      );
      if (!valido) {
        setDest(null);
        posicionOrigen
          ? setSearchTermDestino({ texto: "", actualizar: true })
          : setSearchTermOrigen({ texto: "", actualizar: true });
        //window.alert("Origen y destino no compatibles");
      }
    }

    //setTextoOrigen(origenNuevo.nombre);
    posicionOrigen
      ? setSpinnerOrigenActivado(false)
      : setSpinnerDestinoActivado(false);

    setOcultarListaOrigen(true);
    setOcultarListaDestino(true);

    posicionOrigen
      ? setListOrigen(props.listaAeropuertosAPI)
      : setListDestino(props.listaAeropuertosAPI);

    //setFechaIda(null);

    return { origenNuevo: origenNuevo, lista: destinos };
  }

  async function seleccionarAeropuertoSinOrigen(elem, posicionOrigen) {
    posicionOrigen
      ? setSpinnerOrigenActivado(true)
      : setSpinnerDestinoActivado(true);

    let origenNuevo = await Llamadas.getTodoAeropuertoNested(elem.id);
    Utils.logger("Origen nuevo");
    Utils.logger(origenNuevo);

    let destinoParam = dest;

    setOrigen({
      ...origenNuevo,
      posicionOrigen: posicionOrigen,
    });
    if (
      !primeroSeleccionado ||
      (primeroSeleccionado?.posicionOrigen == posicionOrigen &&
        !(origenNuevo && destinoParam)) ||
      origenNuevo.posicionOrigen == destinoParam.posicionOrigen
    ) {
      setPrimeroSeleccionado({
        ...origenNuevo,
        posicionOrigen: posicionOrigen,
      });
      setDestinosDesactivado(false);
      setFechasDesactivado(false);
      setFechasVueltaDesactivado(false);
      setCambiarDesactivado(false);
      if (destinoParam) {
        destinoParam = undefined;
        setDest(destinoParam);
      }
    }

    let borrar = false;
    if (destinoParam && origenNuevo) {
      if (destinoParam) {
        let valido = await Llamadas.validarOrigenDestino(
          origenNuevo,
          destinoParam
        );
        if (!valido) {
          setDest(undefined);
          borrar = true;
          posicionOrigen
            ? setSearchTermDestino({ texto: "", actualizar: false })
            : setSearchTermOrigen({ texto: "", actualizar: false });
          //window.alert("Origen y destino no compatibles");
        }
      }
    }

    //Stop sales
    if (elem.stopSales) {
      setFechasExcluidas([
        {
          start: Utils.convertUTCToLocalTime(elem.fechaInicioStopSales),
          end: Utils.convertUTCToLocalTime(elem.fechaFinStopSales),
        },
      ]);
    }

    posicionOrigen
      ? setSearchTermOrigen({ texto: origenNuevo.nombre, actualizar: false })
      : setSearchTermDestino({ texto: origenNuevo.nombre, actualizar: false });

    posicionOrigen
      ? setSpinnerOrigenActivado(false)
      : setSpinnerDestinoActivado(false);

    setOcultarListaOrigen(true);
    setOcultarListaDestino(true);

    posicionOrigen ? setListDestino([]) : setListOrigen([]);

    if (destinoParam && !borrar) {
      return filtrarFechasTarifa(destinoParam, origenNuevo);
    }

    //setListCopia(destinos);
    //setList(destinos);
    //seleccionarDestino(dest, origenNuevo, posicionOrigen);
    //setFechaIda(null);
  }

  //Funcíon usada para llamar a tomtom y devolver los resultados según el texto introducido
  async function filtrarResultadosCargar(
    texto,
    placeId,
    origenParam = origen,
    listaDestinos = listaDinamicaDestinos
  ) {
    if (texto != "") {
      setSpinnerDestinoActivado(true);
      setListDestino([]);
      setOcultarListaDestino(false);

      if (!(origenParam && origenParam.tarifas)) {
        //window.alert("Debe seleccionar primero un origen");
        return [];
      }

      const placeResults = await Utils.tomTomGetPlaceById(placeId);

      let lista = mostrarSugerencias(placeResults, texto, listaDestinos, false);
      return lista;
    } else {
      if (origenParam) {
        let listaTemp = mostrarSugerencias([], texto, listaDestinos, false);
        return listaTemp;
      } else {
        setListDestino([]);
        return [];
      }
    }
  }

  async function filtrarResultadosNuevo(texto) {
    if (texto !== "") {
    	let listaRepetidos = [];
    	let listaPoligonos = [];

		 if(props.areas.length===0){
			  var listaAreas= await Llamadas.getAreas();
			  listaAreas?.items.forEach((area) => {
					  if (!listaRepetidos.some((a) => a.id === area.id)) {
						listaRepetidos.push(area);
						listaPoligonos.push({
						  type: "POLYGON",
						  vertices: area.coordenadas
							.split(";")
							.map((item) => {
							  let limpio = item
								.replace(/\s+/g, "")    // Elimina espacios y saltos de línea
								.replace(/,0\.0$/, ""); // Elimina ,0.0 al final

							  const partes = limpio.split(",");
							  if (partes.length === 2) {
								return `${partes[1]},${partes[0]}`; // Invierte lat,lng -> lng,lat
							  }
							  return limpio; // Por si no tiene dos partes, lo deja como está
							}),
						});
					  }
					});
					props.areas = listaPoligonos;
					props.areasOriginales =listaAreas.items;
					}
		  else{
			  listaPoligonos = props.areas;
		  }


      if (listaPoligonos.length === 0) {
        //window.alert("Buscador no disponible para este origen");
        return [];
      }

      var filtrado = await Utils.getFiltradoTomtomNuevo(
        texto,
        listaPoligonos,
        Liferay.ThemeDisplay.getBCP47LanguageId()
      );
      let parsear = await Utils.parsearResultadosTomtom(filtrado?.results);
      return parsear;
    } else {
      return [];
    }
  }

  //Funcíon usada para llamar a tomtom y devolver los resultados según el texto introducido
  async function filtrarResultados(
    texto,
    origenParam = origen,
    listaDestinos = listaDinamicaDestinos,
    posicionOrigen = true
  ) {
    if (texto != "") {
      posicionOrigen
        ? setSpinnerOrigenActivado(true)
        : setSpinnerDestinoActivado(true);

      posicionOrigen ? setListOrigen([]) : setListDestino([]);

      posicionOrigen
        ? setOcultarListaOrigen(false)
        : setOcultarListaDestino(false);

      let listaPoligonos = [];
      let listaRepetidos = [];
      if (origenParam && origenParam.tarifas) {
        origenParam.tarifas.forEach((tarifa) => {
          if (tarifa.areasConPrecios) {
            tarifa.areasConPrecios.forEach((area) => {
              if (!listaRepetidos.some((a) => a.id === area.id)) {
                listaRepetidos.push(area);
                listaPoligonos.push({
                  type: "POLYGON",
                  vertices: area.coordenadas
                    .split(";")
                    .map((item) => item.trim()),
                });
              }
            });
          }
        });

        if (listaPoligonos.length == 0) {
          //window.alert("Buscador no disponible para este origen");
          let listaTemp = mostrarSugerencias(
            [],
            texto,
            listaDestinos,
            posicionOrigen
          );
          return listaTemp;
        }
      } else {
        return [];
      }

      var resultados = await Utils.tomtomGeometricSearch(
        Liferay.ThemeDisplay.getLanguageId(),
        texto,
        listaPoligonos
      );

      let lista = mostrarSugerencias(
        resultados,
        texto,
        listaDestinos,
        posicionOrigen
      );
      
      return lista;
    } else {
      //limpiarCampo(posicionOrigen);
      if (origenParam) {
        let listaTemp = mostrarSugerencias(
          [],
          texto,
          listaLocalizaciones,
          posicionOrigen
        );
        posicionOrigen?setMensajeVacioOrigenActivado(false):setMensajeVacioDestinoActivado(false);
        return listaTemp;
      } else {
        posicionOrigen ? setListOrigen([]) : setListDestino([]);
        posicionOrigen?setMensajeVacioOrigenActivado(false):setMensajeVacioDestinoActivado(false);

        posicionOrigen
          ? setOcultarListaOrigen(true)
          : setOcultarListaDestino(true);

        return [];
      }
    }
  }

  //Función usada para obtener las fechas a mostrar en los datepickers
  async function filtrarFechasTarifa(destino, origenParam = origen) {
    let lista = [];
    let tarifasValidas = [];
    Utils.logger(origenParam);
    const result = await Utils.filtrarTarifasPorDestino(origenParam, destino);
    tarifasValidas = result.tarifasValidas;
    lista = result.lista;

    if (tarifasValidas.length == 0) {
      //alertdestinoinvalido
      //window.alert("Destino inválido, por favor seleccione otro");
      window.alert(Llamadas.traducir(trad.alertdestinoinvalido_i18n));

      return;
    }

    if (lista.length == 0) {
      //alertfechasdisponibles
      //window.alert("No hay fechas disponibles");
      window.alert(Llamadas.traducir(trad.alertfechasdisponibles_i18n));
      return;
    } else {
      Utils.logger("Lista Tarifas");
      Utils.logger(lista);
      setFechasValidas(lista);

      //validar horas por defecto
      let validacionIda = validarFechaIda(new Date());
      setHoraMax(validacionIda.horaMaxima);
      setHoraMin(validacionIda.horaMinima);

      setFechasValidasVuelta(lista);
      setListaTarifasValidas(tarifasValidas);

      //Comprobar si fecha ya esta metida y si vale, si no error
      if (fechaIda) {
        let res = false;
        lista.forEach((f) => {
          if (
            fechaIda.getTime() >= f.start.getTime() &&
            fechaIda.getTime() <= f.end.getTime()
          ) {
            res = true;
          }
        });

        if (!res) {
          //alertfechaseleccionadainvalida
          /*window.alert(
            "Fecha seleccionada inválida para ese origen y destino, por favor introduzca otra"
          );*/
          window.alert(Llamadas.traducir(trad.alertfechaseleccionadainvalida_i18n));

          setFechaIda(undefined);
          setFechaVuelta(undefined);
        } else {
          let resultado = validarFechaIda(fechaIda, lista, tarifasValidas);
          setFechasValidasVuelta(resultado.listaTemp);

          if (!(Utils.isMismoDia(fechaIda, resultado?.fecha))) {


            seleccionarFechaIda(resultado?.fecha, true, lista, tarifasValidas);

            setocultarHorasTrasOK(true);
            actualizarFechaIdaConHoras(resultado?.fecha, resultado?.fecha.getHours(), resultado?.fecha.getMinutes());

          }

          //seleccionarFechaIda(fechaIda, lista, tarifasValidas);
          //setocultarHorasTrasOK(true);
          //actualizarFechaIdaConHoras(fechaIda,fechaIda.getHours(),fechaIda.getMinutes());
        }
      }

      return { tarifasValidas: tarifasValidas, fechasValidas: lista };
    }
  }

  //Función usada para mostrar los resultados de tomtom en el selector de destino
  function mostrarSugerencias(
    predictions,
    texto,
    listaParam = listaDinamicaDestinos,
    posicionOrigen = true
  ) {
    if (!predictions) {
      //alert(status);
      return;
    }
    //document.getElementById("results").innerHTML="";
    /*
    let listaTemp = listaParam.filter((elem) =>
      Utils.eliminarAcentos(elem.nombre.toUpperCase()).includes(
        Utils.eliminarAcentos(texto.toUpperCase())
      )
    );*/
    let listaTemp = busquedaFuzzy(listaParam, texto, ["nombre"]);

    predictions.forEach((prediction) => {
      //const li = document.createElement("li");
      let coor = "";
      let nuevo = {
        poi: false,
        nombrePOI: "",
        place_id: prediction.id,
        nombre: prediction.address.freeformAddress,
        location: prediction.position.lng + "," + prediction.position.lat,
        lat: prediction.position.lat,
        lon: prediction.position.lng,
        type: "coord",
      };

      if (prediction.type == "POI") {
        nuevo = {
          poi: true,
          coordenadas: prediction.position.lng + "," + prediction.position.lat,
          lat: prediction.position.lat,
          lon: prediction.position.lng,
          nombrePOI: prediction.poi.name,
          place_id: prediction.id,
          nombre:
            prediction.poi.name + " - " + prediction.address.freeformAddress,
          location: prediction.position.lng + "," + prediction.position.lat,
          type: "coord",
          tipoDestino: "tomtom",
        };
      }
      /*li.addEventListener("click", () => {
        coor=seleccionarDestino(nuevo);
      });*/

      listaTemp.push(nuevo);
      //Utils.logger(listaDinamica);
      //li.appendChild(document.createTextNode(" description: "+ nuevo.description +""));
      //document.getElementById("results").appendChild(li);
    });
    posicionOrigen ? setListOrigen(listaTemp) : setListDestino(listaTemp);
    if(listaTemp?.length == 0) {
      posicionOrigen ? setMensajeVacioOrigenActivado(true) : setMensajeVacioDestinoActivado(true);
    } else {
      posicionOrigen ? setMensajeVacioOrigenActivado(false) : setMensajeVacioDestinoActivado(false);
    }
    posicionOrigen
      ? setSpinnerOrigenActivado(false)
      : setSpinnerDestinoActivado(false);

    return listaTemp;
  }

  //Funcíon usada para seleccionar el destino, sea una area o localizacion
  function seleccionarDestino(
    elem,
    origenParam = origen,
    posicionOrigen = true,
    cargando = false
  ) {
    if (elem) {
      setDest({
        ...elem,
        posicionOrigen: posicionOrigen,
      });

      if (
        (!primeroSeleccionado && !cargando) ||
        (primeroSeleccionado?.posicionOrigen == posicionOrigen &&
          !(origenParam && elem) && !cargando) ||
        (origenParam.posicionOrigen == elem.posicionOrigen && !cargando)
      ) {
        setPrimeroSeleccionado({ ...elem, posicionOrigen: posicionOrigen });
        setDestinosDesactivado(false);
        setFechasDesactivado(false);
        setFechasVueltaDesactivado(false);
        setCambiarDesactivado(false);
        if (origenParam) {
          origenParam = undefined;
          setOrigen(origenParam);
        }
      }
      //document.getElementById("info-resultado").innerHTML="location: "+elem.location+ " address: "+ elem.description;
      setFechasDesactivado(false);
      posicionOrigen
        ? setOcultarListaOrigen(true)
        : setOcultarListaDestino(true);

      posicionOrigen
        ? setListDestino(props.listaAeropuertosAPI)
        : setListOrigen(props.listaAeropuertosAPI);

      let desc = "";
      desc = elem.nombre;
      posicionOrigen
        ? setSearchTermOrigen({ texto: desc, actualizar: false })
        : setSearchTermDestino({ texto: desc, actualizar: false });

      return filtrarFechasTarifa(elem, origenParam);
    } else {
      console.error("No results found seleccionar destino");
      return;
    }
  }

  function validarFechaIda(
    fechaParam,
    fechasValidasParam = fechasValidas,
    tarifasValidasParam = tarifasValidas,
    origenParam = origen,
    fechasExcluidasparam = fechasExcluidas
  ) {
    let fecha = fechaParam;
    Utils.logger("");
    Utils.logger(fecha.toISOString());
    Utils.logger("Dia:");
    Utils.logger(fecha.getDay());

    let redondeo = 1000 * 60 * 5;

    let horaMinima = Utils.ajustarHora(fecha, 0, 0);
    let horaMaxima = Utils.ajustarHora(fecha, 23, 59);

    let nueva = Utils.getFechaMinimaPlazo(
      origenParam?.horasDePlazo,
      origenParam?.minutosDePlazo
    );

    let listaTemp = [];
    fechasValidasParam.forEach((f) => {
      if (Utils.isMismoDia(fecha, f.start)) {
        horaMinima = Utils.ajustarHora(
          f.start,
          f.start.getHours(),
          f.start.getMinutes()
        );
      }
      if (Utils.isMismoDia(fecha, f.end)) {
        horaMaxima = Utils.ajustarHora(
          f.end,
          f.end.getHours(),
          f.end.getMinutes()
        );
      }

      //comprobar si fecha es menor que el plazo
      let fechaMinima = fecha;
      if (nueva.getTime() > fecha) {
        fechaMinima = nueva;
      }

      if (
        fechaMinima.getTime() >= f.start.getTime() &&
        fechaMinima.getTime() <= f.end.getTime()
      ) {
        listaTemp.push({ start: fechaMinima, end: f.end });
      } else {
        listaTemp.push(f);
      }
    });

    Utils.logger("listatemp ida");
    Utils.logger(listaTemp);
    Utils.logger("horasmaximas");
    Utils.logger(horaMinima);
    Utils.logger(horaMaxima);

    //Stop sales
    if (origenParam?.stopSales) {
      if (Utils.isMismoDia(fecha, fechasExcluidasparam[0].start)) {
        horaMaxima = Utils.ajustarHora(
          fecha,
          fechasExcluidasparam[0].start.getHours(),
          fechasExcluidasparam[0].start.getMinutes()
        );
      }
      if (Utils.isMismoDia(fecha, fechasExcluidasparam[0].end)) {
        horaMinima = Utils.ajustarHora(
          fecha,
          fechasExcluidasparam[0].end.getHours(),
          fechasExcluidasparam[0].end.getMinutes()
        );
      }
    }

    Utils.logger("horasmaximas con stopsales");
    Utils.logger(horaMinima);
    Utils.logger(horaMaxima);

    Utils.logger(fecha);

    //redondear hora minima si es el mismo dia
    if (Utils.isMismoDia(fecha, nueva)) {
      horaMinima = new Date(
        Math.ceil(horaMinima.getTime() / redondeo) * redondeo
      );
    }

    //comprobar si fecha con limite es menor que hora minima normal
    if (nueva.getTime() > horaMinima.getTime()) {
      if (Utils.isMismoDia(horaMinima, nueva)) {
        horaMinima = Utils.ajustarHora(
          nueva,
          nueva.getHours(),
          nueva.getMinutes()
        );
      } else {
        horaMinima = Utils.ajustarHora(nueva, 23, 59);
      }
    }

    Utils.logger("horaminima si es mismo dia");
    Utils.logger(horaMinima);

    //hora minima al cambiar de dia
    if (fechaIda) {
      if (!Utils.isMismoDia(fecha, fechaIda)) {
        fecha = horaMinima;
      }
    }
    Utils.logger("horaminima al cambiar de dia");
    Utils.logger(fecha);

    if (
      (fecha.getHours() == horaMinima.getHours() &&
        fecha.getMinutes() == horaMinima.getMinutes()) ||
      (fecha.getHours() == nueva.getHours() &&
        fecha.getMinutes() == nueva.getMinutes()) ||
      fecha.getMinutes() % 5 != 0
    ) {
      fecha = Utils.ajustarHora(fecha, fecha.getHours(), fecha.getMinutes());
    }

    if (
      fecha.getHours() >= horaMaxima.getHours() &&
      fecha.getMinutes() >= horaMaxima.getMinutes()
    ) {
      fecha = Utils.ajustarHora(
        fecha,
        horaMaxima.getHours(),
        horaMaxima.getMinutes()
      );
    }
    if (
      (fecha.getHours() < horaMinima.getHours() &&
        fecha.getMinutes() < horaMinima.getMinutes()) ||
      fecha.getMinutes() % 5 != 0
    ) {
      fecha = Utils.ajustarHora(
        fecha,
        horaMinima.getHours(),
        horaMinima.getMinutes()
      );
    }

    Utils.logger("fecha al comprobar horas");
    Utils.logger(fecha);
    let resultado = {
      fecha: fecha,
      horaMinima: horaMinima,
      horaMaxima: horaMaxima,
      nueva: nueva,
      listaTemp: listaTemp,
    };
    Utils.logger("validar fecha ida");
    Utils.logger(resultado);

    return resultado;
  }

  function validarFechaVuelta(
    fechaParam,
    fechasValidasParam = fechasValidas,
    tarifasValidasParam = tarifasValidas,
    origenParam = origen,
    fechaIdaParam = fechaIda,
    fechasExcluidasparam = fechasExcluidas
  ) {
    let fecha = fechaParam;
    Utils.logger(fecha.toISOString());
    Utils.logger("Dia:");
    Utils.logger(fecha.getDay());

    let redondeo = 1000 * 60 * 5;

    let horaMinima = Utils.ajustarHora(fechaParam, 0, 0);
    let horaMaxima = Utils.ajustarHora(fechaParam, 23, 59);

    let nueva = Utils.getFechaMinimaPlazo(
      origenParam?.horasDePlazo,
      origenParam?.minutosDePlazo
    );

    fechasValidasParam.forEach((f) => {
      if (Utils.isMismoDia(fecha, f.start)) {
        horaMinima = Utils.ajustarHora(
          fecha,
          f.start.getHours(),
          f.start.getMinutes()
        );
      }
      if (Utils.isMismoDia(fecha, f.end)) {
        horaMaxima = Utils.ajustarHora(
          fecha,
          f.end.getHours(),
          f.end.getMinutes()
        );
      }
    });

    //Stop sales
    if (origenParam?.stopSales) {
      if (Utils.isMismoDia(fecha, fechasExcluidasparam[0].start)) {
        horaMaxima = Utils.ajustarHora(
          fecha,
          fechasExcluidasparam[0].start.getHours(),
          fechasExcluidasparam[0].start.getMinutes()
        );
      }
      if (Utils.isMismoDia(fecha, fechasExcluidasparam[0].end)) {
        horaMinima = Utils.ajustarHora(
          fecha,
          fechasExcluidasparam[0].end.getHours(),
          fechasExcluidasparam[0].end.getMinutes()
        );
      }
    }

    Utils.logger(fecha);
    Utils.logger(horaMinima);
    Utils.logger(horaMaxima);

    //hora minima al cambiar de dia
    if (fechaIdaParam) {
      if (Utils.isMismoDia(fecha, fechaIdaParam)) {
        horaMinima = fechaIdaParam;
      }
    }

    //redondear hora minima si es el mismo dia
    if (
      Utils.isMismoDia(fecha, nueva) &&
      horaMinima.getTime() < nueva.getTime()
    ) {
      horaMinima = new Date(
        Math.ceil(horaMinima.getTime() / redondeo) * redondeo
      );
    }

    //hora minima al cambiar de dia
    if (fechaVuelta) {
      if (!Utils.isMismoDia(fecha, fechaVuelta)) {
        fecha = horaMinima;
      }
    }

    if (
      fecha.getMinutes() % 5 != 0) {
      fecha = Utils.ajustarHora(
        fecha,
        horaMinima.getHours(),
        horaMinima.getMinutes()
      );
    }
    if (
      fecha.getTime() < horaMinima.getTime()
    ) {
      fecha = Utils.ajustarHora(
        fecha,
        horaMinima.getHours(),
        horaMinima.getMinutes()
      );
    }
    return { horaMinima, horaMaxima, fecha };
  }

  //Funcíon usada para seleccionar la fecha de ida en el datepicker
  function seleccionarFechaIda(
    fechaParam, activarPasajeros,
    fechasValidasParam = fechasValidas,
    tarifasValidasParam = tarifasValidas,
    origenParam = origen,
    fechasExcluidasparam = fechasExcluidas
  ) {
    let resultado = validarFechaIda(
      fechaParam,
      fechasValidasParam,
      tarifasValidasParam,
      origenParam,
      fechasExcluidasparam
    );

    let { fecha, nueva, horaMaxima, horaMinima, listaTemp } = resultado;

    //Hora minima vuelta si es el mismo dia
    let hoy = new Date();
    if (Utils.isMismoDia(hoy, nueva)) {
      setHoraMinVuelta(nueva);
      setHoraMaxVuelta(horaMaxima);
    } else {
      setHoraMinVuelta(Utils.ajustarHora(hoy, 23, 59));
      setHoraMaxVuelta(Utils.ajustarHora(hoy, 23, 59));
    }

    Utils.logger(fecha);
    Utils.logger(horaMinima);
    Utils.logger(horaMaxima);

    setdiaSeleccionado(fecha);
    setFechasValidasVuelta(listaTemp);
    setHoraMax(horaMaxima);
    setHoraMin(horaMinima);
    setFechaVuelta(null);
    setdiaSeleccionadoVuelta(undefined);
    sethoraSeleccionadaVuelta(undefined);
    setMinutoSeleccionadoVuelta(undefined);
    setFechasVueltaDesactivado(false);

    if (horaSeleccionada != undefined && minutoSeleccionado != undefined) {
      let horaNueva = horaSeleccionada;
      let minutoNuevo = minutoSeleccionado;
      let fechaAntigua = Utils.ajustarHora(fecha, horaSeleccionada, minutoSeleccionado);
      if (fechaAntigua.getTime() < horaMinima.getTime() || fechaAntigua.getTime() > horaMaxima.getTime()) {
        sethoraSeleccionada(fecha.getHours());
        setMinutoSeleccionado(fecha.getMinutes());
        horaNueva = fecha.getHours();
        minutoNuevo = fecha.getMinutes();
      }
      actualizarListaMinutos(horaMinima, horaMaxima, horaNueva, true);

    }


let fechaCompletaNueva = new Date(fecha);

// Le asignamos la hora y los minutos
fechaCompletaNueva.setHours(horaSeleccionada);
fechaCompletaNueva.setMinutes(minutoSeleccionado);


    setFechaIda(fechaCompletaNueva);

  //  actualizarFechaIdaConHoras
    //pasajeros
    let { minPersonas, maxPersonas } = Utils.getMaxMinPasajeros(
      tarifasValidasParam,
      fecha
    );
    if (minPersonas > 1 && minPersonas != Infinity) {
      setPasajeros({
        adultos: minPersonas,
        ninos: 0,
        bebes: 0,
      });
      getTextoPasajeros({
        adultos: minPersonas,
        ninos: 0,
        bebes: 0,
      });
    }

    //setListaPasajeros(listaopciones);
    Utils.logger("min y max pasajeros");
    Utils.logger(minPersonas);
    Utils.logger(maxPersonas);
    setMaxPasajeros(maxPersonas);
    setMinPasajeros(minPersonas);
    if (activarPasajeros) {
      setPasajerosDesactivado(false);
    }
    setEnviarDesactivado(false);
    setocultarHorasTrasOK(false);
    setocultarHorasTrasOKVuelta(true);
    setHechoDeshabilitado(false);

    return listaTemp;
  }

  //Función usada para seleccionar la fecha de vuelta en el datepicker
  function seleccionarFechaVuelta(
    fechaParam,
    fechasValidasParam = fechasValidasVuelta,
    tarifasValidasParam = tarifasValidas,
    origenParam = origen,
    fechaIdaParam = fechaIda,
    fechasExcluidasparam = fechasExcluidas
  ) {
    let { horaMinima, horaMaxima, fecha } = validarFechaVuelta(
      fechaParam,
      fechasValidasParam,
      tarifasValidasParam,
      origenParam,
      fechaIdaParam,
      fechasExcluidasparam
    );

    Utils.logger(fecha);
    Utils.logger(horaMinima);
    Utils.logger(horaMaxima);

    //pasajeros
    let { minPersonas, maxPersonas } = Utils.getMaxMinPasajeros(
      tarifasValidasParam,
      fecha
    );
    if (minPersonas > 1 && minPersonas != Infinity) {
      setPasajeros({
        adultos: minPersonas,
        ninos: 0,
        bebes: 0,
      });
      getTextoPasajeros({
        adultos: minPersonas,
        ninos: 0,
        bebes: 0,
      });
    }
    //setListaPasajeros(listaopciones);
    Utils.logger("min y max pasajeros");
    Utils.logger(minPersonas);
    Utils.logger(maxPersonas);

    setHoraMaxVuelta(horaMaxima);
    setHoraMinVuelta(horaMinima);
    setMaxPasajeros(maxPersonas);
    setMinPasajeros(minPersonas);
    setPasajerosDesactivado(false);
    setEnviarDesactivado(false);
    setdiaSeleccionadoVuelta(fecha);
    setocultarHorasTrasOKVuelta(false);
    setocultarHorasTrasOK(true);

    setHechoDeshabilitadoVuelta(false);
    if (horaSeleccionadaVuelta != undefined && minutoSeleccionadoVuelta != undefined) {
      let horaNueva = horaSeleccionadaVuelta;
      let minutoNuevo = minutoSeleccionadoVuelta;
      let fechaAntigua = Utils.ajustarHora(fecha, horaSeleccionadaVuelta, minutoSeleccionadoVuelta);
      if (fechaAntigua.getTime() < horaMinima.getTime() || fechaAntigua.getTime() > horaMaxima.getTime()) {
        sethoraSeleccionadaVuelta(fecha.getHours());
        horaNueva = fecha.getHours();
        minutoNuevo = fecha.getMinutes();
        setMinutoSeleccionadoVuelta(fecha.getMinutes());
      }
      actualizarListaMinutos(horaMinima, horaMaxima, horaNueva, false);
    } else {
      sethoraSeleccionadaVuelta(horaMinima.getHours());
      setMinutoSeleccionadoVuelta(horaMinima.getMinutes());
    }

    let fechaCompletaNueva = new Date(fecha);

    // Le asignamos la hora y los minutos
    fechaCompletaNueva.setHours(horaSeleccionada);
    fechaCompletaNueva.setMinutes(minutoSeleccionado);


        setFechaVuelta(fechaCompletaNueva);
  }

  function ocultarDesplegablesHoras() {
    setocultarHoras(true);
    setocultarHorasVuelta(true);
    setocultarMinutos(true);
    setocultarMinutosVuelta(true);
  }

  //Función usada para enviar los datos rellenados al formulario
  async function enviarDatos() {

  const today = new Date();
  const diffTime = fechaIda - today;
  const daysInAdvance = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  const fechaIdaFormateada = format(fechaIda, 'dd/MM/yyyy', { locale: es });
const fechaVueltaFormateada = fechaVuelta? format?.(fechaVuelta, 'dd/MM/yyyy', { locale: es })
  : null;

  dataLayer.push({
  event: 'eventoGA',
  catEvent:  'Proceso Reserva Traslado',
  actEvento: '0. Home',
  etiqEvento: 'NA',
  origen: origen.posicionOrigen
          ?origen.nombre
          :dest.nombre,
  destino: dest.posicionOrigen
           ?origen.nombre
           :dest.nombre,
  fecha_ida: fechaIdaFormateada,
  fecha_vuelta: fechaVueltaFormateada,
  n_pasajeros: pasajeros.adultos + pasajeros.ninos + pasajeros.bebes,
  n_adultos: pasajeros.adultos,
  n_ninos: pasajeros.ninos,
  n_bebes: pasajeros.bebes,
  tipo_producto: '',
  journey: origen.posicionOrigen
  		? origen.nombre+'-'+dest.nombre
  		:dest.nombre + '-'+origen.nombre,
  tipo_usuario_compra:'No Registrado',
  paso_proceso: "0.Home",
  dias_antelacion:daysInAdvance,

   });


    //http://localhost:8080/?aeropuertoId=33894&type=coord&fechaIda=2024-03-31T13:00:00&placeId=EjJDYWxsZSBkZSBsYSBNYWdkYWxlbmEsIENlbnRybywgMjgwMTIgTWFkcmlkLCBTcGFpbiIuKiwKFAoSCc00lpkqJkINEWccrnky0qDrEhQKEgmBPAqAlylCDRFpIoxhwd42xA
    Utils.logger(origen);
    Utils.logger(dest);
    let origenAeropuertoParam = false;
    if (
      primeroSeleccionado?.posicionOrigen ==
      (primeroSeleccionado?.tipoDestino == "estacion")
    ) {
      origenAeropuertoParam = origenAeropuerto;
    } else {
      origenAeropuertoParam = !origenAeropuerto;
    }
    window.location.href = await Llamadas.getUrlFormulario(
      origen,
      dest,
      origenAeropuertoParam,
      fechaIda,
      pasajeros,
      fechaVuelta
    );
  }

  //CAMBIO DE ORIGEN Y DESTINO
  async function cambiarOrigenDestino() {
    //setDest(null);
    //setOrigen(null);
    //setList([]);
    //setListaPasajeros([]);
    //setDestinosDesactivado(true);
    //setDestinosAeropuertoDesactivado(true);
    //setFechasDesactivado(true);
    //setFechasVueltaDesactivado(true);
    //setPasajerosDesactivado(true);
    //setEnviarDesactivado(true);

    /*
    if(origen!=undefined && dest!=undefined){
      if(primeroSeleccionado?.posicionOrigen==origen.posicionOrigen){
        //Si el origen es el primero seleccionado, cambiarlo a destino
        setPrimeroSeleccionado(dest);
      } else{
        setPrimeroSeleccionado(origen);
      }
    }*/

    setOrigenAeropuerto(!origenAeropuerto);

    /*
      if(origenRefCambiado.current){
        origenRefCambiado.current.value=textoOrigen;
      }
      if(destinoRefCambiado.current){
        destinoRefCambiado.current.value=textoDestino;
      }
      if(origenRef.current){
        origenRef.current.value=textoOrigen;
      }
      if(destinoRef.current){
        destinoRef.current.value=textoDestino;
      }
    */
  }

  //Función usada para incializar el buscador con los valores que se pasen en la url al volver desde el formulario
  async function cargarVariables(listaAeropuertos) {

  let url = window.location.pathname.split('/').filter(Boolean).pop();
  let aeropuertoPredefinido=null;
  aeropuertoPredefinido =listaAeropuertos.find((a) => a.url === url);


    Utils.logger(variables);
    if (variables.fechaIda != undefined && variables.fechaIda != null) {
      let orden = true;
      if (variables.origenNoAeropuerto == "true") {
        //await cambiarOrigenDestino();
        orden = false;
      }
      let aeropuerto = listaAeropuertos.find(
        (a) => a.id === variables.aeropuertoId
      );
      Utils.logger(aeropuerto);

      let listaOrigen = filtrarAmbos(aeropuerto.nombre, orden);
      let objSeleccion = await seleccionarAeropuerto(aeropuerto, orden);
      Utils.logger(objSeleccion);
      let destino;
      //await setTextoOrigen(objSeleccion.origenNuevo.nombre);
      if (variables.type == "coord") {
        let listaResultados = await filtrarResultadosCargar(
          variables.nombreDestino,
          variables.placeId,
          objSeleccion.origenNuevo,
          objSeleccion.lista
        );
        Utils.logger(listaResultados);
        destino = listaResultados.find((d) => d.place_id === variables.placeId);
      } else {
        destino = objSeleccion.lista.find(
          (d) => d.key === variables.destination
        );
      }
      Utils.logger(destino);
      let desc = destino.nombre;
      //await setTextoDestino(desc);
      let validas = await seleccionarDestino(
        destino,
        objSeleccion.origenNuevo,
        !orden,
        true
      );
      Utils.logger("validas cargar");
      Utils.logger(validas);

      let listaValidaVuelta = seleccionarFechaIda(
        new Date(variables.fechaIda), true,
        validas.fechasValidas,
        validas.tarifasValidas,
        objSeleccion.origenNuevo
      );
      setocultarHorasTrasOK(true);
      setFechaIda(new Date(variables.fechaIda));
      if (variables.fechaVuelta) {
        seleccionarFechaVuelta(
          new Date(variables.fechaVuelta),
          listaValidaVuelta,
          validas.tarifasValidas,
          objSeleccion.origenNuevo,
          new Date(variables.fechaIda)
        );
        setocultarHorasTrasOKVuelta(true);
        setFechaVuelta(variables.fechaVuelta);
      }
      await setPasajeros(variables.pasajeros);
      getTextoPasajeros(variables.pasajeros);
      setOcultarListaDestino(true);
      setOcultarListaOrigen(true);
    }
    else if(aeropuertoPredefinido!=null){
    	let listaOrigen = filtrarAmbos(aeropuertoPredefinido.nombre, true);
        let objSeleccion = await seleccionarAeropuerto(aeropuertoPredefinido, true);
    }
    await setVariablesCargar(false);
  }

  //Función usada para cambiar los valores de pasajeros, sea adultos, ninos o bebes
  function cambiarPasajero(campo, cantidad) {
    let pasajerosNuevo;
    if (campo == "adultos") {
      pasajerosNuevo = {
        adultos: cantidad,
        ninos: pasajeros.ninos,
        bebes: pasajeros.bebes,
      };
    } else if (campo == "ninos") {
      pasajerosNuevo = {
        adultos: pasajeros.adultos,
        ninos: cantidad,
        bebes: pasajeros.bebes,
      };
    } else if (campo == "bebes") {
      pasajerosNuevo = {
        adultos: pasajeros.adultos,
        ninos: pasajeros.ninos,
        bebes: cantidad,
      };
    }
    setPasajeros(pasajerosNuevo);
    getTextoPasajeros(pasajerosNuevo);
  }

  //Función usada para concatenar los números de pasajeros y mostrarlo al pulsar confirmar
  function getTextoPasajeros(pasajerosParam = pasajeros) {
    let texto = "";
    let textoAdulto = Llamadas.traducir(trad.adulto_i18n).toLocaleLowerCase();
    let textoNino = Llamadas.traducir(trad.nino_i18n).toLocaleLowerCase();
    let textoBebe = Llamadas.traducir(trad.bebe_i18n).toLocaleLowerCase();
    if (pasajerosParam.adultos >= 1) {
      if (pasajerosParam.adultos >= 2)
        textoAdulto = Llamadas.traducir(trad.adultos_i18n)?.toLocaleLowerCase();
      texto += pasajerosParam.adultos + " " + textoAdulto;
    }

    if (pasajerosParam.ninos >= 1) {
      if (pasajerosParam.ninos >= 2)
        textoNino = Llamadas.traducir(trad.ninos_i18n)?.toLocaleLowerCase();
      texto += ", " + pasajerosParam.ninos + " " + textoNino;
    }

    if (pasajerosParam.bebes >= 1) {
      if (pasajerosParam.bebes >= 2)
        textoBebe = Llamadas.traducir(trad.bebes_i18n)?.toLocaleLowerCase();
      texto += ", " + pasajerosParam.bebes + " " + textoBebe;
    }
    setTextoPasajeros(texto);
  }

  function onBlurOrigenDestino(e, posicionOrigen = true) {
    if (e.relatedTarget?.nodeName != "LI") {
      setOcultarListaOrigen(true);
      setOcultarListaDestino(true);

      if (primeroSeleccionado) {
        let nombre = undefined;
        if (origen?.posicionOrigen == posicionOrigen) {
          nombre = origen?.nombre;
        }
        if (dest?.posicionOrigen == posicionOrigen) {
          nombre = dest?.nombre;
        }

        if (posicionOrigen) {
          if (searchTermOrigen.texto != nombre && nombre != undefined) {
            if (
              dest?.posicionOrigen == false ||
              origen?.posicionOrigen == true
            ) {
              filtrarAeropuertos("", true);
            } else {
              filtrarResultados("", origen, listaLocalizaciones, true);
            }
            setSearchTermOrigen({ texto: nombre, actualizar: false });
          }
        } else {
          if (searchTermDestino.texto != nombre && nombre != undefined) {
            if (
              dest?.posicionOrigen == false ||
              origen?.posicionOrigen == true
            ) {
              filtrarResultados("", origen, listaLocalizaciones, false);
            } else {
              filtrarAeropuertos("", false);
            }
            setSearchTermDestino({ texto: nombre, actualizar: false });
          }
        }
      }
    }
     //console.log("Llego al final");

      if (dest === undefined && origen === undefined) {

     // console.log("dest y origen es undefined");
              setSearchTermDestino({ texto: "", actualizar: false });
                setSearchTermOrigen({ texto: "", actualizar: false });
      }
    if ((dest === undefined || origen === undefined)&& !posicionOrigen) {
      //console.log("dest es undefined");
        setSearchTermDestino({ texto: "", actualizar: false });

    }
   /* if (origen === undefined&& posicionOrigen) {
      console.log("origen es undefined");
        setSearchTermOrigen({ texto: "", actualizar: false });

    }*/
  }

  function onBlurPasajeros(e) {
    Utils.logger("Blur pasajeros");
    Utils.logger(e);
    if (
      e.relatedTarget?.nodeName != "LI" &&
      e.relatedTarget?.nodeName != "BUTTON"
    ) {
      setPasajeroCerrado(true);
    }
  }

  function onBlurHoras(e, ida) {
    Utils.logger("Blur pasajeros");
    Utils.logger(e);
    if (
      e.relatedTarget?.nodeName != "LI"
    ) {
      ida ? setocultarHoras(true) : setocultarHorasVuelta(true);
    }
  }

  function onBlurMinutos(e, ida) {
    Utils.logger("Blur pasajeros");
    Utils.logger(e);
    if (
      e.relatedTarget?.nodeName != "LI"
    ) {
      ida ? setocultarMinutos(true) : setocultarMinutosVuelta(true);
    }
  }

  function onBlurCalendar(calendario) {
    //e.preventDefault();
    Utils.logger("blur calendario nueva prueba");
    let open = calendario.current.isCalendarOpen();
    Utils.logger("open calendario");
    Utils.logger(calendario.current.isCalendarOpen());
    calendario.current.setOpen(!open);
  }

  function isAeropuertoPrimero() {
    let origenAeropuertoParam = false;
    if (
      primeroSeleccionado?.posicionOrigen ==
      (primeroSeleccionado?.tipoDestino == "estacion")
    ) {
      origenAeropuertoParam = origenAeropuerto;
    } else {
      origenAeropuertoParam = !origenAeropuerto;
    }
    return origenAeropuertoParam;
  }

  function limpiarCampo(posicionOrigen) {

    let primero = primeroSeleccionado;/*
    if(origenAeropuerto==false){
      if(primero?.tipoDestino == "estacion"){
        primero=dest;
      } else{
        primero=origen;
      }
    }*/

    if (origen?.posicionOrigen == posicionOrigen) {
      limpiarOrigen(posicionOrigen, primero);
    } else if (dest?.posicionOrigen == posicionOrigen) {
      limpiarDestino(posicionOrigen, primero);
    }
  }

  function limpiarOrigen(posicionOrigen, primero) {
    setOrigen(undefined);
    posicionOrigen ? setListOrigen([]) : setListDestino([]);
    if (primero?.tipoDestino == "estacion") {
      setPrimeroSeleccionado(undefined);
      setDestinosDesactivado(true);
      setFechasDesactivado(true);
      setFechasVueltaDesactivado(true);
      setCambiarDesactivado(true);
    }
    if (primero?.posicionOrigen == posicionOrigen) {
      setDest(undefined);
      setListLocalizaciones([]);
      deshabilitarCamposBorrar(posicionOrigen);
      posicionOrigen ? setListDestino([]) : setListOrigen([]);
      setPrimeroSeleccionado(undefined);
      setDestinosDesactivado(true);
      setFechasDesactivado(true);
      setFechasVueltaDesactivado(true);
      setCambiarDesactivado(true);
      posicionOrigen ? setSearchTermDestino({ texto: "", actualizar: true }) : setSearchTermOrigen({ texto: "", actualizar: true });
    }
    posicionOrigen ? setSearchTermOrigen({ texto: "", actualizar: true }) : setSearchTermDestino({ texto: "", actualizar: true });

  }

  function limpiarDestino(posicionOrigen, primero) {
    setDest(undefined);
    let lista = [];
    if (primero?.tipoDestino != "estacion") {
      setPrimeroSeleccionado(undefined);
      setDestinosDesactivado(true);
      setFechasDesactivado(true);
      setFechasVueltaDesactivado(true);
      setCambiarDesactivado(true);
    }
    if (primero?.posicionOrigen == posicionOrigen) {
      setOrigen(undefined);
      deshabilitarCamposBorrar(posicionOrigen);
      posicionOrigen ? setListDestino([]) : setListOrigen([]);
      posicionOrigen ? setSearchTermDestino({ texto: "", actualizar: true }) : setSearchTermOrigen({ texto: "", actualizar: true });
    } else {
      lista = listaLocalizaciones;
    }
    posicionOrigen ? setListOrigen(lista) : setListDestino(lista);
    posicionOrigen ? setSearchTermOrigen({ texto: "", actualizar: true }) : setSearchTermDestino({ texto: "", actualizar: true });

  }

  function deshabilitarCamposBorrar(posicionOrigen) {
    if (origenAeropuerto) {
      if (posicionOrigen) {
        setDestinosDesactivado(true);
        setOrigenDesactivado(false);
      } else {
        setOrigenDesactivado(true);
        setDestinosDesactivado(false);
      }
    } else {
      if (posicionOrigen) {
        setOrigenDesactivado(false);
        setDestinosDesactivado(true);
      } else {
        setDestinosDesactivado(false);
        setOrigenDesactivado(true);
      }
    }
    setCambiarDesactivado(true);
  }

  function actualizarFechas() {
    if (horaSeleccionada != undefined && minutoSeleccionado != undefined && diaSeleccionado != undefined) {
      actualizarFechaIdaConHoras(diaSeleccionado, horaSeleccionada, minutoSeleccionado);
    }
    if (horaSeleccionadaVuelta != undefined && minutoSeleccionadoVuelta != undefined && diaSeleccionadoVuelta != undefined) {
      actualizarFechaVueltaConHoras(diaSeleccionadoVuelta, horaSeleccionadaVuelta, minutoSeleccionadoVuelta);
    }
  }

  const getDiaSeleccionado = () => {
    if (fechaIda) {
      return fechaIda;
    } else {
      if (diaSeleccionado != undefined && horaSeleccionada != undefined && minutoSeleccionado != undefined) {
        return Utils.ajustarHora(diaSeleccionado, horaSeleccionada, minutoSeleccionado);
      } else {
        return diaSeleccionado;
      }
    }
  }

  const getDiaSeleccionadoVuelta = () => {
    if (fechaVuelta) {
      return fechaVuelta;
    } else {
      if (diaSeleccionadoVuelta != undefined && horaSeleccionadaVuelta != undefined && minutoSeleccionadoVuelta != undefined) {
        return Utils.ajustarHora(diaSeleccionadoVuelta, horaSeleccionadaVuelta, minutoSeleccionadoVuelta);
      } else {
        return diaSeleccionadoVuelta;
      }
    }
  }

  return (
    <>
      {variablesCargar ? (
        <Suspense fallback={<div></div>}>
          <Spinner></Spinner>
        </Suspense>
      ) : (

        <div class="box-container">
          <div class="box-search align-items-center">
            <img class="mb-2" src="/o/spain-transfers-theme/assets/sm/images/home/Infografia_Coche.svg" alt="infografia coche" style={{ width: "354px", height: "45px" }} />
            <h2>{Llamadas.traducir(trad.tellevamos_i18n)}</h2>
            <form>
              <button
                disabled={cambiarDesactivado}
                class="btn-origdest"
                type="button"
                onClick={() => cambiarOrigenDestino()}
              >
                <img
                  src="/o/spain-transfers-theme/assets/sm/icons/general/cambiarDestinos.svg"
                  alt="Icono de flechas: cambio de destino"
                  class="imgBtn"
                />
              </button>
              <div class="row">
                <div class="col-12">
                  {origenAeropuerto ? (
                    <div class="input-container">
                      <input
                        style={(origen?.posicionOrigen == true || dest?.posicionOrigen == true) || spinnerOrigenActivado ? { paddingTop: "20px", paddingRight: "40px" } : { paddingTop: "20px" }}
                        value={searchTermOrigen.texto}
                        autoComplete="off"
                        type="text"
                        maxLength={90}
                        id="origen"
                        disabled={origenDesactivado}
                        class="input-container-input"
                        placeholder={Llamadas.traducir(
                          trad?.placeholderorigen_i18n
                        )}
                        onChange={(e) =>
                          setSearchTermOrigen({
                            texto: e.target.value,
                            actualizar: true,
                          })
                        }
                        onBlur={(e) => onBlurOrigenDestino(e, true)}
                        onClick={() => {
                          setOcultarListaOrigen(!ocultarListaOrigen);
                          setOcultarListaDestino(true);
                        }}
                      />
                      <label
                        for="origen"
                        className={
                          "input-container-label " +
                          (searchTermOrigen.texto != "" || origen
                            ? "label-traslt"
                            : "")
                        }
                      >
                        {Llamadas.traducir(trad.bodyorigen_i18n)}
                      </label>
                      <button
                        style={(origen?.posicionOrigen || dest?.posicionOrigen) && !spinnerOrigenActivado ? {} : { display: "none" }}
                        type="button"
                        class="react-datepicker__closedate"
                        aria-label="borrar fecha"
                        title="Borrar fecha"
                        onClick={() => limpiarCampo(true)}
                      >
                        <img
                          src="/o/spain-transfers-theme/assets/sm/icons/general/close-circle.svg"
                          alt="Icono borrar fecha"
                          class="icoClosedate"
                        />
                      </button>
                      <div
                        style={
                          spinnerOrigenActivado ? {} : { display: "none" }
                        }
                        class="spinner-input"
                      >
                        <svg
                          id="spinner-origen"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          className="spinner"
                        >
                          <path
                            fill="#1f9792"
                            d="M12,23a9.63,9.63,0,0,1-8-9.5,9.51,9.51,0,0,1,6.79-9.1A1.66,1.66,0,0,0,12,2.81h0a1.67,1.67,0,0,0-1.94-1.64A11,11,0,0,0,12,23Z"
                          />
                        </svg>
                      </div>

                      {listaDinamicaOrigen.length > 0 ? (

                      <div
                        class="box-destino"
                        style={
                          ocultarListaOrigen
                            ? { display: "none" }
                            : { display: "flex" }
                        }
                      >
                        <ul
                          class="sugerencias"
                          id="lista-origen"
                          style={
                            ocultarListaOrigen
                              ? { display: "none" }
                              : { display: "flex" }
                          }
                        >
                          {listaDinamicaOrigen.length > 0
                            ? listaDinamicaOrigen.map((item) => (
                              <li
                                tabindex="0"
                                style={{ cursor: "pointer" }}
                                class="origen"
                                onClick={(e) =>
                                  seleccionarElemento(item, true)
                                }
                              >
                                {" "}
                                {item.nombre}{" "}
                              </li>
                            ))
                            : ""}
                        </ul>
                      </div>

                      ) : <MensajeVacio mostrar={!ocultarListaOrigen && searchTermOrigen.texto!="" && mensajeVacioOrigenActivado} texto={Llamadas.traducir(trad.mensajevacioorigen_i18n)}></MensajeVacio>}

                    </div>
                  ) : (
                    <div class="input-container">
                      <input
                        style={(origen?.posicionOrigen == false || dest?.posicionOrigen == false) || spinnerDestinoActivado ? { paddingTop: "20px", paddingRight: "40px" } : { paddingTop: "20px" }}
                        value={searchTermDestino.texto}
                        disabled={destinosDesactivado}
                        autoComplete="off"
                        type="text"
                        maxLength={100}
                        id="destino"
                        class="input-container-input"
                        placeholder={Llamadas.traducir(
                          trad?.placeholderdestino_i18n
                        )}
                        required
                        onChange={(e) =>
                          setSearchTermDestino({
                            texto: e.target.value,
                            actualizar: true,
                          })
                        }
                        onBlur={(e) => onBlurOrigenDestino(e, false)}
                        onClick={() => {
                          setOcultarListaDestino(!ocultarListaDestino);
                          setOcultarListaOrigen(true);
                        }}
                      />
                      <label
                        for="destino"
                        className={
                          "input-container-label " +
                          (searchTermDestino.texto != "" || dest
                            ? "label-traslt"
                            : "")
                        }
                      >
                        {Llamadas.traducir(trad.origencambiado_i18n)}
                      </label>
                      <button
                        style={(origen?.posicionOrigen == false || dest?.posicionOrigen == false) && !spinnerDestinoActivado ? {} : { display: "none" }}
                        type="button"
                        class="react-datepicker__closedate"
                        aria-label="borrar fecha"
                        title="Borrar fecha"
                        onClick={() => limpiarCampo(false)}
                      >
                        <img
                          src="/o/spain-transfers-theme/assets/sm/icons/general/close-circle.svg"
                          alt="Icono borrar fecha"
                          class="icoClosedate"
                        />
                      </button>
                      <div
                        style={
                          spinnerDestinoActivado
                            ? {}
                            : { display: "none" }
                        }
                        class="spinner-input"
                      >
                        <svg
                          id="spinner-origen"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          className="spinner"
                        >
                          <path
                            fill="#1f9792"
                            d="M12,23a9.63,9.63,0,0,1-8-9.5,9.51,9.51,0,0,1,6.79-9.1A1.66,1.66,0,0,0,12,2.81h0a1.67,1.67,0,0,0-1.94-1.64A11,11,0,0,0,12,23Z"
                          />
                        </svg>
                      </div>
                      {/* Resultados destino */}

                      {listaDinamicaDestinos?.length>0?(
                      <div
                        class="box-destino"
                        style={
                          ocultarListaDestino
                            ? { display: "none" }
                            : { display: "flex" }
                        }
                      >
                        <ul
                          class="sugerencias"
                          id="lista-destino"
                          style={
                            ocultarListaDestino
                              ? { display: "none" }
                              : { display: "flex" }
                          }
                        >
                          {listaDinamicaDestinos.length > 0
                            ? listaDinamicaDestinos.map((item) => (
                              <li
                                tabindex="0"
                                style={{ cursor: "pointer" }}
                                class="origen"
                                onClick={(e) =>
                                  seleccionarElemento(item, false)
                                }
                              >
                                {" "}
                                {item.nombre}{" "}
                              </li>
                            ))
                            : ""}
                        </ul>
                      </div>

                      ) : <MensajeVacio mostrar={!ocultarListaDestino && searchTermDestino.texto!=""  && mensajeVacioDestinoActivado} texto={Llamadas.traducir(trad.mensajevacioorigen_i18n)}></MensajeVacio>}
                      {/*<div class="invalid-feedback" style={{display:"block"}}>Mensaje de error</div>*/}
                    </div>
                  )}
                </div>

                <div class="col-12">
                  {origenAeropuerto ? (
                    <div class="input-container">
                      <input
                        style={(origen?.posicionOrigen == false || dest?.posicionOrigen == false) || spinnerDestinoActivado ? { paddingTop: "20px", paddingRight: "40px" } : { paddingTop: "20px" }}
                        value={searchTermDestino.texto}
                        disabled={destinosDesactivado}
                        autoComplete="off"
                        type="text"
                        maxLength={100}
                        id="destino"
                        class="input-container-input"
                        placeholder={Llamadas.traducir(
                          trad?.placeholderdestino_i18n
                        )}
                        required
                        onChange={(e) =>
                          setSearchTermDestino({
                            texto: e.target.value,
                            actualizar: true,
                          })
                        }
                        onBlur={(e) => onBlurOrigenDestino(e, false)}
                        onClick={() => {
                          setOcultarListaDestino(!ocultarListaDestino);
                          setOcultarListaOrigen(true);
                        }}
                      />
                      <label
                        for="destino"
                        className={
                          "input-container-label " +
                          (searchTermDestino.texto != "" || dest
                            ? "label-traslt"
                            : "")
                        }
                      >
                        {Llamadas.traducir(trad.bodydestino_i18n)}
                      </label>
                      <button
                        style={(origen?.posicionOrigen == false || dest?.posicionOrigen == false) && !spinnerDestinoActivado ? {} : { display: "none" }}
                        type="button"
                        class="react-datepicker__closedate"
                        aria-label="borrar fecha"
                        title="Borrar fecha"
                        onClick={() => limpiarCampo(false)}
                      >
                        <img
                          src="/o/spain-transfers-theme/assets/sm/icons/general/close-circle.svg"
                          alt="Icono borrar fecha"
                          class="icoClosedate"
                        />
                      </button>
                      <div
                        style={
                          spinnerDestinoActivado
                            ? {}
                            : { display: "none" }
                        }
                        class="spinner-input"
                      >
                        <svg
                          id="spinner-origen"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          className="spinner"
                        >
                          <path
                            fill="#1f9792"
                            d="M12,23a9.63,9.63,0,0,1-8-9.5,9.51,9.51,0,0,1,6.79-9.1A1.66,1.66,0,0,0,12,2.81h0a1.67,1.67,0,0,0-1.94-1.64A11,11,0,0,0,12,23Z"
                          />
                        </svg>
                      </div>
                      {/* Resultados destino */}

                      {listaDinamicaDestinos?.length>0 ? (

                      <div
                        class="box-destino"
                        style={
                          ocultarListaDestino
                            ? { display: "none" }
                            : { display: "flex" }
                        }
                      >
                        <ul
                          class="sugerencias"
                          id="lista-destino"
                          style={
                            ocultarListaDestino
                              ? { display: "none" }
                              : { display: "flex" }
                          }
                        >
                          {listaDinamicaDestinos.length > 0
                            ? listaDinamicaDestinos.map((item) => (
                              <li
                                tabindex="0"
                                style={{ cursor: "pointer" }}
                                class="origen"
                                onClick={(e) =>
                                  seleccionarElemento(item, false)
                                }
                              >
                                {" "}
                                {item.nombre}{" "}
                              </li>
                            ))
                            : ""}
                        </ul>
                      </div>
                      ) : <MensajeVacio mostrar={!ocultarListaDestino && searchTermDestino.texto!=""  && mensajeVacioDestinoActivado} texto={Llamadas.traducir(trad.mensajevaciodestino_i18n)}></MensajeVacio>}

                      {/*<div class="invalid-feedback" style={{display:"block"}}>Mensaje de error</div>*/}
                    </div>
                  ) : (
                    <div class="input-container">
                      <input
                        style={(origen?.posicionOrigen == true || dest?.posicionOrigen == true) || spinnerOrigenActivado ? { paddingTop: "20px", paddingRight: "40px" } : { paddingTop: "20px" }}
                        value={searchTermOrigen.texto}
                        autoComplete="off"
                        type="text"
                        maxLength={90}
                        id="origen"
                        disabled={origenDesactivado}
                        class="input-container-input"
                        placeholder={Llamadas.traducir(
                          trad?.placeholderorigen_i18n
                        )}
                        onChange={(e) =>
                          setSearchTermOrigen({
                            texto: e.target.value,
                            actualizar: true,
                          })
                        }
                        onBlur={(e) => onBlurOrigenDestino(e, true)}
                        onClick={() => {
                          setOcultarListaOrigen(!ocultarListaOrigen);
                          setOcultarListaDestino(true);
                        }}
                      />
                      <label
                        for="origen"
                        className={
                          "input-container-label " +
                          (searchTermOrigen.texto != "" || origen
                            ? "label-traslt"
                            : "")
                        }
                      >
                        {Llamadas.traducir(trad.destinocambiado_i18n)}
                      </label>
                      <button
                        style={(origen?.posicionOrigen || dest?.posicionOrigen) && !spinnerOrigenActivado ? {} : { display: "none" }}
                        type="button"
                        class="react-datepicker__closedate"
                        aria-label="borrar fecha"
                        title="Borrar fecha"
                        onClick={() => limpiarCampo(true)}
                      >
                        <img
                          src="/o/spain-transfers-theme/assets/sm/icons/general/close-circle.svg"
                          alt="Icono borrar fecha"
                          class="icoClosedate"
                        />
                      </button>
                      <div
                        style={
                          spinnerOrigenActivado ? {} : { display: "none" }
                        }
                        class="spinner-input"
                      >
                        <svg
                          id="spinner-origen"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          className="spinner"
                        >
                          <path
                            fill="#1f9792"
                            d="M12,23a9.63,9.63,0,0,1-8-9.5,9.51,9.51,0,0,1,6.79-9.1A1.66,1.66,0,0,0,12,2.81h0a1.67,1.67,0,0,0-1.94-1.64A11,11,0,0,0,12,23Z"
                          />
                        </svg>
                      </div>

                      {listaDinamicaOrigen.length > 0 ? (
                      <div
                        class="box-destino"
                        style={
                          ocultarListaOrigen
                            ? { display: "none" }
                            : { display: "flex" }
                        }
                      >
                        <ul
                          class="sugerencias"
                          id="lista-origen"
                          style={
                            ocultarListaOrigen
                              ? { display: "none" }
                              : { display: "flex" }
                          }
                        >
                          {listaDinamicaOrigen.length > 0
                            ? listaDinamicaOrigen.map((item) => (
                              <li
                                tabindex="0"
                                style={{ cursor: "pointer" }}
                                class="origen"
                                onClick={(e) =>
                                  seleccionarElemento(item, true)
                                }
                              >
                                {" "}
                                {item.nombre}{" "}
                              </li>
                            ))
                            : ""}
                        </ul>
                      </div>

                      ) : <MensajeVacio mostrar={!ocultarListaOrigen && searchTermOrigen.texto!=""  && mensajeVacioOrigenActivado} texto={Llamadas.traducir(trad.mensajevaciodestino_i18n)}></MensajeVacio>}


                    </div>
                  )}
                </div>

                <div class="col-6 col-sm-6 pr-1">
                  <div id="dtp-left" class="input-container">
                    <DatePicker
                      ref={CalendarioIdaRef}
                      dateFormat={"d MMMM · HH:mm"}
                      selected={getDiaSeleccionado()}
                      locale={locale}
                      includeDateIntervals={fechasValidas.map(
                        (fecha) => ({
                          start: subDays(fecha.start, 1),
                          end: addDays(fecha.end, 1),
                        })
                      )}
                      excludeDateIntervals={fechasExcluidas.map(
                        (fecha) => ({
                          start: addDays(fecha.start, 1),
                          end: subDays(fecha.end, 1),
                        })
                      )}
                      customInput={
                        <InputPersonalizado className="input-container-input" />
                      }
                      onChange={(e) => {
                        seleccionarFechaIda(e, true);
                        setTimeout(() => {
                          if (CalendarioIdaRef.current) {
                            CalendarioIdaRef.current.setOpen(false);
                          }
                          // document.getElementById("hora-picker").focus();
                        }, 100);
                      }}
                    />
                  </div>
                </div>
                <div class="col-6 col-sm-6 pl-1">
                  <div id="dtp-right" class="input-container">
                    <DatePicker
                      ref={CalendarioVueltaRef}
                      dateFormat={"d MMMM · HH:mm"}
                      selected={getDiaSeleccionadoVuelta()}
                      locale={locale}
                      includeDateIntervals={fechasValidasVuelta.map(
                        (fecha) => ({
                          start: subDays(fecha.start, 1),
                          end: addDays(fecha.end, 1),
                        })
                      )}
                      excludeDateIntervals={fechasExcluidas.map(
                        (fecha) => ({
                          start: addDays(fecha.start, 1),
                          end: subDays(fecha.end, 1),
                        })
                      )}
                      minTime={horaMinVuelta}
                      maxTime={horaMaxVuelta}
                      customInput={
                        <InputPersonalizadoVuelta className="input-container-input" />
                      }
                      onChange={(e) => seleccionarFechaVuelta(e)}
                    />
                  </div>
                </div>
                {!ocultarHorasTrasOK && (
                  <div className="col-12" ref={hhmmRef}
                    style={{ display: ocultarHorasTrasOK ? "none" : "block" }}>
                    <div className="box-time">
                      <p className="text-time">
                          {Llamadas.traducir(trad.textohorasida_i18n)}
                      </p>
                      <div className="div-hhmm">
                        <div className="box-hm">
                          <input
                            autoComplete="off"
                            type="text"
                            className="input-hm"
                            id="idHora"
                            placeholder="HH"
                            value={horaSeleccionada}
                            onClick={() => setocultarHoras(!ocultarHoras)}
                          />
                          {ocultarHoras ? (
                            ""
                          ) : (
                            <ul
                              ref={ulRef}
                              className="ul-boxhm"
                              id="idBoxh"
                              style={{ display: "block" }}
                            >
                              {getListaHoras().map((elem) => (
                                <li
                                  key={elem}
                                  className="li-boxhm li-h"
                                  tabIndex="0"
                                  onClick={() => seleccionarHora(elem)}
                                >
                                  {elem}
                                </li>
                              ))}
                              <li className="li-boxhm li-h"></li>
                            </ul>
                          )}
                        </div>
                        <span className="span-hm">:</span>
                        <div className="box-hm">
                          <input
                            autoComplete="off"
                            type="text"
                            className="input-hm"
                            id="idMinuto"
                            placeholder="MM"
                            value={minutoSeleccionado}
                            onClick={() =>
                              setocultarMinutos(!ocultarMinutos)
                            }
                          />
                          {ocultarMinutos ? (
                            ""
                          ) : (
                            <ul
                              className="ul-boxhm"
                              id="idBoxm"
                              style={{ display: "block" }}
                            >
                              {listaMinutosValidos.map((elem) => (
                                <li
                                  className="li-boxhm li-m"
                                  onClick={() => seleccionarMinuto(elem)}
                                >
                                  {elem}
                                </li>
                              ))}
                              <li className="li-boxhm li-h"></li>
                            </ul>
                          )}
                        </div>
                      </div>
                      <button
                        class="btn btn-primary"
                        id="btnHecho"
                        disabled={hechoDeshabilitado}
                        onClick={() => {
                          setocultarHorasTrasOK(true);
                          actualizarFechaIdaConHoras(diaSeleccionado, horaSeleccionada, minutoSeleccionado);
                        }}
                      >
                        {Llamadas.traducir(trad.botonhorasida_i18n)}
                      </button>
                    </div>
                  </div>
                )}
                {!ocultarHorasTrasOKVuelta && (
                  <div className="col-12" ref={hhmmRefVuelta}
                    style={{ display: ocultarHorasTrasOKVuelta ? "none" : "block" }}>
                    <div className="box-time">
                      <p className="text-time">
                        {Llamadas.traducir(trad.textohorasvuelta_i18n)}
                      </p>
                      <div className="div-hhmm">
                        <div className="box-hm">
                          <input
                            autoComplete="off"
                            type="text"
                            className="input-hm"
                            id="idHora"
                            placeholder="HH"
                            value={horaSeleccionadaVuelta}
                            onClick={() =>
                              setocultarHorasVuelta(!ocultarHorasVuelta)
                            }
                          />
                          {ocultarHorasVuelta ? (
                            ""
                          ) : (
                            <ul
                              className="ul-boxhm"
                              id="idBoxh"
                              style={{ display: "block" }}
                            >
                              {getListaHorasVuelta().map((elem) => (
                                <li
                                  className="li-boxhm li-h"
                                  onClick={() =>
                                    seleccionarHoraVuelta(elem)
                                  }
                                >
                                  {elem}
                                </li>
                              ))}
                              <li className="li-boxhm li-h"></li>
                            </ul>
                          )}
                        </div>
                        <span className="span-hm">:</span>
                        <div className="box-hm">
                          <input
                            autoComplete="off"
                            type="text"
                            className="input-hm"
                            id="idMinuto"
                            placeholder="MM"
                            value={minutoSeleccionadoVuelta}
                            onClick={() =>
                              setocultarMinutosVuelta(
                                !ocultarMinutosVuelta
                              )
                            }
                          />
                          {ocultarMinutosVuelta ? (
                            ""
                          ) : (
                            <ul
                              className="ul-boxhm"
                              id="idBoxm"
                              style={{ display: "block" }}
                            >
                              {listaMinutosValidosVuelta.map((elem) => (
                                <li
                                  className="li-boxhm li-m"
                                  onClick={() =>
                                    seleccionarMinutoVuelta(elem)
                                  }
                                >
                                  {elem}
                                </li>
                              ))}
                              <li className="li-boxhm li-h"></li>
                            </ul>
                          )}
                        </div>
                      </div>
                      <button
                        class="btn btn-primary"
                        id="btnHecho"
                        disabled={hechoDeshabilitadoVuelta && horaSeleccionadaVuelta != undefined && minutoSeleccionadoVuelta != undefined}
                        onClick={() => {
                          setocultarHorasTrasOKVuelta(true);
                          actualizarFechaVueltaConHoras(diaSeleccionadoVuelta, horaSeleccionadaVuelta, minutoSeleccionadoVuelta);
                        }}
                      >
                        {Llamadas.traducir(trad.botonhorasvuelta_i18n)}
                      </button>
                    </div>
                  </div>
                )}
                <div class="col-12">
                  <div class="input-container">
                    <label
                      for="pasajeros"
                      className={"input-container-label label-traslt"}
                    >
                      {Llamadas.traducir(trad.bodypasajeros_i18n)}
                    </label>
                    <input
                      style={{ cursor: "pointer", paddingTop: "20px" }}
                      autoComplete="off"
                      value={textoPasajeros}
                      readOnly
                      type="text"
                      name="pasajeros"
                      id="pasajeros"
                      disabled={pasajerosDesactivado}
                      class="input-container-input ici-select"
                      onClick={() => {
                        setPasajeroCerrado(!pasajeroCerrado);
                        //setPasajerosDesactivado(!pasajerosDesactivado);
                      }}
                      onBlur={(e) => onBlurPasajeros(e)}
                    />
                    <ul
                      class="box-paxoption"
                      style={{
                        display: pasajeroCerrado ? "none" : "flex",
                        overflowY: "hidden",
                      }}
                    >
                      {minPasajeros > 1 ? (
                        <li tabindex="0" class="lipax">
                          <div class="box-textpax">
                            <p
                              class="text-pax title-pax"
                              style={{ color: "#eb6821" }}
                            >
                              {Llamadas.traducir(
                                trad?.mensajeminpasajeros_i18n
                              )?.replace("##num##", minPasajeros)}
                            </p>
                          </div>
                        </li>
                      ) : (
                        ""
                      )}

                      <li tabindex="0" class="lipax">
                        <div class="box-textpax">
                          <p class="text-pax title-pax">
                            {Llamadas.traducir(trad.adultos_i18n)}
                          </p>
                          <p class="text-pax">
                            {Llamadas.traducir(trad.adultosedad_i18n)}
                          </p>
                        </div>
                        <div class="box-counting">
                          <button
                            disabled={
                              pasajeros.adultos +
                              pasajeros.ninos +
                              pasajeros.bebes <=
                              minPasajeros || pasajeros.adultos == 1
                            }
                            type="button"
                            class="btn-counting btn-less"
                            onClick={() =>
                              cambiarPasajero(
                                "adultos",
                                pasajeros.adultos - 1
                              )
                            }
                            onBlur={(e) => onBlurPasajeros(e)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 13H5V11H19V13Z"
                                fill="#AFC5CD"
                              />
                            </svg>
                          </button>
                          <span class="counting">
                            {pasajeros.adultos}
                          </span>
                          <button
                            disabled={
                              pasajeros.adultos +
                              pasajeros.ninos +
                              pasajeros.bebes >=
                              maxPasajeros
                            }
                            type="button"
                            class="btn-counting btn-plus"
                            onClick={() =>
                              cambiarPasajero(
                                "adultos",
                                pasajeros.adultos + 1
                              )
                            }
                            onBlur={(e) => onBlurPasajeros(e)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                                fill="#EB6821"
                              />
                            </svg>
                          </button>
                        </div>
                      </li>

                      <li tabindex="0" class="lipax">
                        <div class="box-textpax">
                          <p class="text-pax title-pax">
                            {Llamadas.traducir(trad.ninos_i18n)}
                          </p>
                          <p class="text-pax">
                            {Llamadas.traducir(trad.ninosedad_i18n)}
                          </p>
                        </div>
                        <div class="box-counting">
                          <button
                            disabled={
                              pasajeros.adultos +
                              pasajeros.ninos +
                              pasajeros.bebes <=
                              minPasajeros || pasajeros.ninos == 0
                            }
                            type="button"
                            class="btn-counting btn-less"
                            onClick={() =>
                              cambiarPasajero(
                                "ninos",
                                pasajeros.ninos - 1
                              )
                            }
                            onBlur={(e) => onBlurPasajeros(e)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 13H5V11H19V13Z"
                                fill="#AFC5CD"
                              />
                            </svg>
                          </button>
                          <span class="counting">{pasajeros.ninos}</span>
                          <button
                            disabled={
                              pasajeros.adultos +
                              pasajeros.ninos +
                              pasajeros.bebes >=
                              maxPasajeros
                            }
                            type="button"
                            class="btn-counting btn-plus"
                            onClick={() =>
                              cambiarPasajero(
                                "ninos",
                                pasajeros.ninos + 1
                              )
                            }
                            onBlur={(e) => onBlurPasajeros(e)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                                fill="#EB6821"
                              />
                            </svg>
                          </button>
                        </div>
                      </li>

                      <li
                        tabindex="0"
                        class="lipax"
                      >
                        <div class="box-textpax">
                          <p class="text-pax title-pax">
                            {Llamadas.traducir(trad.bebes_i18n)}
                          </p>
                          <p class="text-pax">
                            {Llamadas.traducir(trad.bebesedad_i18n)}
                          </p>
                        </div>
                        <div class="box-counting">
                          <button
                            type="button"
                            class="btn-counting btn-less"
                            disabled={
                              pasajeros.adultos +
                              pasajeros.ninos +
                              pasajeros.bebes <=
                              minPasajeros || pasajeros.bebes == 0
                            }
                            onClick={() =>
                              cambiarPasajero(
                                "bebes",
                                pasajeros.bebes - 1
                              )
                            }
                            onBlur={(e) => onBlurPasajeros(e)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 13H5V11H19V13Z"
                                fill="#AFC5CD"
                              />
                            </svg>
                          </button>
                          <span class="counting">{pasajeros.bebes}</span>
                          <button
                            type="button"
                            class="btn-counting btn-plus"
                            disabled={
                              pasajeros.adultos +
                              pasajeros.ninos +
                              pasajeros.bebes >=
                              maxPasajeros
                            }
                            onClick={() =>
                              cambiarPasajero(
                                "bebes",
                                pasajeros.bebes + 1
                              )
                            }
                            onBlur={(e) => onBlurOrigenDestino(e)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                                fill="#EB6821"
                              />
                            </svg>
                          </button>
                        </div>
                      </li>

                      <li tabindex="0" class="lipax">
                        <button
                          onClick={() => {
                            setPasajeroCerrado(true);
                            getTextoPasajeros();
                          }}
                          class="btn btn-primary btn-confirmar"
                          id="confPax"
                          type="button"
                        >
                          {Llamadas.traducir(
                            trad.pasajerosconfirmar_i18n
                          )}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </form>
              <div class="col-12 p-0">
                      <button   ref={botonRef}
                        disabled={
                          !(
                            origen &&
                            dest &&
                            fechaIda &&
                            pasajeros &&
                            !enviarDesactivado
                          )
                        }
                        onClick={() =>

                        enviarDatos()}
                        class="btn btn-primary w-100"
                      >
                        {Llamadas.traducir(trad.buscartraslado_i18n)}
                      </button>
                    </div>
          </div>

        </div>

      )}
    </>
  );
}

export default Buscador;
